<template>
  <div v-if="!isExitCode" id="share" style="height: 100%">
    <!-- <div style="width:100%;height:36px;display: flex;z-index: 1029;background-color: #000;filter: blur(55px);-webkit-backdrop-filter: blur(55px);backdrop-filter: blur(55px);" v-if="(type == 4 || type == 5) && !isPhone"></div> -->
    <div
      v-if="type == 4 || type == 5"
      ref="diagramMain"
      class="diagram-main"
      style="height: calc(100%)"
    >
      <!-- <div style="width:75.5px;height:100%;background-color: #000;filter: blur(55px);-webkit-backdrop-filter: blur(55px);backdrop-filter: blur(55px);display: flex;z-index: 1029;" v-if="!isPhone"></div> -->
      <div ref="container" class="diagram-container">
        <div style="display: flex; height: 100%">
          <div class="diagram-wrapper">
            <div ref="diagram" class="lf-diagram" @wheel="handleScroll"></div>
            <div class="DiagramRBToolbarDiv">
              <div class="flex_x" style="justify-content: flex-end">
                <DiagramRBToolbar
                  v-if="lf"
                  :is-projection="isProjection"
                  :is-exit-previous="isExitPrevious"
                  :is-exit-next="isExitNext"
                  :lf="lf"
                  :transform="transformSize"
                  :is-share="isShare"
                  :is-change-rate="isChangeRate"
                  @getTransformSize="getTransformSize"
                  @changeRate="changeRate"
                  @setIsSilentMode="setIsSilentMode"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <RunResult
      :dialog-visible="dialogVisible"
      :list="dataList"
      :source-list="sourceDataList"
      :is-home-work="isHomeWork"
      @info="getInfo"
      @createDemoList="createDemoList"
      @getNavigationList="getNavigationList"
      @getThemeName="getThemeName"
    ></RunResult>
    <DemonstrateDialog
      v-if="!isDemo"
      :dialog-visible="DemonstrateDialogVisible"
      :list="showDemoList"
      :theme-name="themeName"
      :navigation-list="navigationList"
      :is-projection="isProjection"
      :is-exit-previous="isExitPrevious"
      :is-exit-next="isExitNext"
      :show="Show"
      @info="getDemonstrateInfo"
      @setSelectMulu="setSelectMulu"
    ></DemonstrateDialog>
    <Demonstrate
      v-else
      :dialog-visible="DemonstrateDialogVisible"
      :list="showDemoList"
      :theme-name="themeName"
      :navigation-list="navigationList"
      :is-projection="isProjection"
      :is-exit-previous="isExitPrevious"
      :is-exit-next="isExitNext"
      :show="Show"
      @info="getDemonstrateInfo"
      @setSelectMulu="setSelectMulu"
    ></Demonstrate>
    <ShowDialog
      user-id="1cf9dc4b-d95f-11ea-af4c-52540005ab01"
      :show="Show"
      :dialog-visible="showDialogVisible"
      :list="showList"
      :session-name="session_name"
      @info="getShowInfo"
    ></ShowDialog>
  </div>
  <div
    v-else
    class="login-wrap"
    style="
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding-top: 0;
    "
  >
    <el-form class="login-container" @submit.prevent>
      <el-form-item>
        <el-input
          v-model="code"
          type="text"
          :placeholder="languageData.tip95"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item>
              <el-input type="password" v-model="password" placeholder="用户密码" autocomplete="off"></el-input>
          </el-form-item> -->
      <el-form-item>
        <el-button type="primary" style="width: 100%" @click="checkCode">
          {{ languageData.enter }}
        </el-button>
      </el-form-item>
      <!-- <el-row style="text-align: center;margin-top: -10px;">
              <el-link type="primary" @click="doRegister">注册账号</el-link>
              <el-link type="primary" @click="">忘记密码</el-link>
          </el-row> -->
      <!-- <iframe scrolling="no" frameborder="no" border="0" id="UI_Login" name="UI_Login" src="//edu.cocorobo.cn/course/login?type=2" style="border: 0px; width: 100%; height: 100%;"></iframe> -->
    </el-form>
  </div>
</template>

<script>
import { ElLoading as Loading } from "element-plus";
import { GPT_BASE_URL } from "./constant";
import screenfull from "screenfull";
import $ from "jquery";
import { v4 as uuidv4 } from "uuid";
import { ElMessageBox as MessageBox } from "element-plus";
import RunResult from "./share/RunResult.vue";
import DiagramRBToolbar from "./toolbar/DiagramRBToolbar.vue";
import DemonstrateDialog from "./dialog/DemonstrateDialog.vue";
import Demonstrate from "./share/Demonstrate.vue";
import ShowDialog from "./dialog/ShowDialog.vue";
import LogicFlow from "@logicflow/core";
import {
  SelectionSelect,
  Snapshot,
  DynamicGroup,
  DndPanel,
  BpmnElement,
  Menu,
} from "@logicflow/extension";
import {
  replace_all_x,
  find_min_x,
  find_max_x,
  replace_all_y,
  find_min_y,
  find_max_y,
} from "../tools/utils";
import { registerCustomElement } from "./node";
import Dagre from "../plugins/Dagre";
import SelectDagre from "../plugins/SelectDagre";
import { touchInit } from "../tools/touchevent.js";
import MiniMap from "../plugins/MiniMap";
// import { changeCanvas } from '../tools/spriteUtilities'
import { initStateNew, addSprite, addSpriteNew, destoryApp } from "../tools/spriteUtilities";
export default {
  name: "Share",
  components: {
    RunResult,
    DemonstrateDialog,
    Demonstrate,
    DiagramRBToolbar,
    ShowDialog,
  },
  data() {
    return {
      isShare: true,
      isChangeRate: false,
      transformSize: 100,
      lf: null,
      type: "",
      dialogVisible: false,
      dataList: [],
      sourceDataList: [],
      isHomeWork: false,
      themeName: "",
      navigationList: [],
      DemonstrateDialogVisible: false,
      showDemoList: [],
      isProjection: false,
      isExitPrevious: false,
      isExitNext: false,
      isFullscreen: false,
      isShowDemoList: false,
      DemoLists: [],
      demoIndex: 0,
      isDemo: false,
      isExitCode: false,
      code: "",
      isPhone: false,
      screenWidth: null,
      newDataAll: {},
      showList: [],
      showDialogVisible: false,
      Show: false,
      session_name: ""
    };
  },
  watch: {
    screenWidth: {
      handler(newVal) {
        if (newVal <= 960) {
          if (document.getElementsByClassName("el-message-box")[0]) {
            this.crossFun(document.getElementsByClassName("el-message-box")[0]);
            document.getElementsByClassName("el-message-box")[0].style.width =
              "100%";
            document.getElementsByClassName("el-message-box")[0].style.height =
              "20%";
            document.getElementsByClassName("el-message-box")[0].style.top =
              "42%";
            document.getElementsByClassName("el-message-box")[0].style.left = "0";
          }
          this.isPhone = true;
        } else {
          this.isPhone = false;
        }
      },
      immediate:true,
    }
  },
  mounted() {
    if (window.location.href.indexOf("cocorobo.cn") != -1) {
      this.languageData = this.zhHansLanguage;
      document.domain = "cocorobo.cn";
    } else if (window.location.href.indexOf("cocorobo.hk") != -1) {
      this.languageData = this.zhHantLanguage;
      document.domain = "cocorobo.hk";
    } else if (window.location.href.indexOf("cocorobo.com") != -1) {
      this.languageData = this.enLanguage;
      document.domain = "cocorobo.com";
    } else {
      this.languageData = this.zhHansLanguage;
    }
    this.screenWidth = window.screen.width;
    window.addEventListener('resize', () => {
      this.screenWidth = window.screen.width;
    });
    // window.addEventListener('beforeunload', e => this.beforeunloadFn(e))
    this.init();
    this.getData();
  },
  destoryed() {
    window.removeEventListener("beforeunload", (e) => this.beforeunloadFn(e));
  },
  methods: {
    beforeunloadFn(e) {
      console.log("刷新或关闭", e);
      // localStorage.clear()
      destoryApp();
    },
    handleScroll(event) {
      if (event.ctrlKey || event.metaKey) {
        // Ctrl键被按下
        return;
      } else {
        event.preventDefault();
        event.stopPropagation();
        // 获取滚动的delta值（向上为正数，向下为负数）
        const delta = event.deltaY || -event.detail;
        let scaleFactor = 0.04;
        let minScale = 24;
        let newScale = this.transformSize;
        newScale += delta * scaleFactor;

        // 限制缩放比例不超过最小值和最大值
        newScale = Math.max(minScale, Math.min(newScale, 400)); // 设置最大缩放比例为3

        this.lf.zoom(newScale / 100);
      }
    },
    getShowInfo(value) {
      this.showDialogVisible = value;
      this.showList = [];
      // window.location.reload()
    },
    changeRate(val) {
      this.isChangeRate = val;
    },
    setIsSilentMode(val) {
      let that = this;
      let lf = that.lf;
      let data = lf.getGraphData();
      if (!val) {
        // 重置右键菜单
        lf.extension.menu.setMenuConfig({
          nodeMenu:
            that.group.length > 0
              ? [
                  {
                    text: that.languageData.Backspace,
                    callback(node) {
                      // console.log(2)
                      that
                        .$confirm(
                          that.languageData.tip18,
                          that.languageData.tip2,
                          {
                            confirmButtonText: that.languageData.confirm,
                            cancelButtonText: that.languageData.cancel,
                            type: "warning",
                          }
                        )
                        .then(() => {
                          that.isDeleteNode = true;
                          let newNodes = [];
                          let newEdges = [];
                          newNodes.push(node);
                          let outgoingEdgeModel = lf.getNodeOutgoingEdge(
                            node.id
                          );
                          if (outgoingEdgeModel.length != 0) {
                            for (let i = 0; i < outgoingEdgeModel.length; i++) {
                              let edge = lf.getEdgeModelById(
                                outgoingEdgeModel[i].id
                              );
                              newEdges.push(edge.getData());
                            }
                          }
                          let incomingEdgeModel = lf.getNodeIncomingEdge(
                            node.id
                          );
                          if (incomingEdgeModel.length != 0) {
                            for (let i = 0; i < incomingEdgeModel.length; i++) {
                              let edge = lf.getEdgeModelById(
                                incomingEdgeModel[i].id
                              );
                              newEdges.push(edge.getData());
                            }
                          }
                          that.sendUpdate(newNodes, newEdges, "delete", 0);
                          lf.deleteNode(node.id);
                          that.isDeleteNode = false;
                          let newData = {
                            nodes: newNodes,
                            edges: newEdges,
                            backgroundUrl: localStorage.getItem("background"),
                          };
                          that.add_Operation(newData, "deleteNode");
                        })
                        .catch(() => {
                          // this.$message({
                          //   type: 'info',
                          //   message: '已取消删除'
                          // });
                        });
                    },
                  },
                  {
                    text: that.languageData.clone,
                    callback(node) {
                      that.isAutomatic = true;
                      lf.cloneNode(node.id);
                      that.isAutomatic = false;
                      that.lf.clearSelectElements();
                      that.activeNodes = [];
                    },
                  },
                  {
                    text: that.languageData.distribute_cards,
                    callback(node) {
                      that.sendNodes = [];
                      that.sendNodes.push(node);
                      that.sendEdges = [];
                      that.showSendDialogVisible = true;
                    },
                  },
                  {
                    text: that.languageData.top,
                    callback(node) {
                      lf.setElementZIndex(node.id, "top");
                      let nodeModel = lf.getNodeModelById(node.id);
                      let data = nodeModel.getData();
                      let newNodes = [];
                      newNodes.push(data);
                      that.sendUpdate(newNodes, [], "update", 0);
                      // let newData = {
                      //   "nodes": newNodes,
                      //   "edges": [],
                      //   "backgroundUrl": localStorage.getItem("background")
                      // }
                      // that.add_Operation(newData, "updateNodeLevel")
                    },
                  },
                  {
                    text: that.languageData.bottom,
                    callback(node) {
                      lf.setElementZIndex(node.id, "bottom");
                      let nodeModel = lf.getNodeModelById(node.id);
                      let data = nodeModel.getData();
                      let newNodes = [];
                      newNodes.push(data);
                      that.sendUpdate(newNodes, [], "update", 0);
                      // let newData = {
                      //   "nodes": newNodes,
                      //   "edges": [],
                      //   "backgroundUrl": localStorage.getItem("background")
                      // }
                      // that.add_Operation(newData, "updateNodeLevel")
                    },
                  },
                  {
                    text: that.languageData.forward,
                    callback(node) {
                      let nodeModel = lf.getNodeModelById(node.id);
                      nodeModel.setZIndex(nodeModel.zIndex + 1);
                      let data = nodeModel.getData();
                      let newNodes = [];
                      data.zIndex = nodeModel.zIndex + 1;
                      newNodes.push(data);
                      that.sendUpdate(newNodes, [], "update", 0);
                      // let newData = {
                      //   "nodes": newNodes,
                      //   "edges": [],
                      //   "backgroundUrl": localStorage.getItem("background")
                      // }
                      // that.add_Operation(newData, "updateNodeLevel")
                    },
                  },
                  {
                    text: that.languageData.backward,
                    callback(node) {
                      let nodeModel = lf.getNodeModelById(node.id);
                      nodeModel.setZIndex(nodeModel.zIndex - 1);
                      let data = nodeModel.getData();
                      let newNodes = [];
                      data.zIndex = nodeModel.zIndex - 1;
                      newNodes.push(data);
                      that.sendUpdate(newNodes, [], "update", 0);
                      // let newData = {
                      //   "nodes": newNodes,
                      //   "edges": [],
                      //   "backgroundUrl": localStorage.getItem("background")
                      // }
                      // that.add_Operation(newData, "updateNodeLevel")
                    },
                  },
                ]
              : [
                  {
                    text: that.languageData.Backspace,
                    callback(node) {
                      // console.log(2)
                      that
                        .$confirm(
                          that.languageData.tip18,
                          that.languageData.tip2,
                          {
                            confirmButtonText: that.languageData.confirm,
                            cancelButtonText: that.languageData.cancel,
                            type: "warning",
                          }
                        )
                        .then(() => {
                          that.isDeleteNode = true;
                          let newNodes = [];
                          let newEdges = [];
                          newNodes.push(node);
                          let outgoingEdgeModel = lf.getNodeOutgoingEdge(
                            node.id
                          );
                          if (outgoingEdgeModel.length != 0) {
                            for (let i = 0; i < outgoingEdgeModel.length; i++) {
                              let edge = lf.getEdgeModelById(
                                outgoingEdgeModel[i].id
                              );
                              newEdges.push(edge.getData());
                            }
                          }
                          let incomingEdgeModel = lf.getNodeIncomingEdge(
                            node.id
                          );
                          if (incomingEdgeModel.length != 0) {
                            for (let i = 0; i < incomingEdgeModel.length; i++) {
                              let edge = lf.getEdgeModelById(
                                incomingEdgeModel[i].id
                              );
                              newEdges.push(edge.getData());
                            }
                          }
                          that.sendUpdate(newNodes, newEdges, "delete", 0);
                          lf.deleteNode(node.id);
                          that.isDeleteNode = false;
                          let newData = {
                            nodes: newNodes,
                            edges: newEdges,
                            backgroundUrl: localStorage.getItem("background"),
                          };
                          that.add_Operation(newData, "deleteNode");
                        })
                        .catch(() => {
                          // this.$message({
                          //   type: 'info',
                          //   message: '已取消删除'
                          // });
                        });
                    },
                  },
                  {
                    text: that.languageData.clone,
                    callback(node) {
                      that.isAutomatic = true;
                      lf.cloneNode(node.id);
                      that.isAutomatic = false;
                      that.lf.clearSelectElements();
                      that.activeNodes = [];
                    },
                  },
                  {
                    text: that.languageData.top,
                    callback(node) {
                      lf.setElementZIndex(node.id, "top");
                      let nodeModel = lf.getNodeModelById(node.id);
                      let data = nodeModel.getData();
                      let newNodes = [];
                      newNodes.push(data);
                      that.sendUpdate(newNodes, [], "update", 0);
                      // let newData = {
                      //   "nodes": newNodes,
                      //   "edges": [],
                      //   "backgroundUrl": localStorage.getItem("background")
                      // }
                      // that.add_Operation(newData, "updateNodeLevel")
                    },
                  },
                  {
                    text: that.languageData.bottom,
                    callback(node) {
                      lf.setElementZIndex(node.id, "bottom");
                      let nodeModel = lf.getNodeModelById(node.id);
                      let data = nodeModel.getData();
                      let newNodes = [];
                      newNodes.push(data);
                      that.sendUpdate(newNodes, [], "update", 0);
                      // let newData = {
                      //   "nodes": newNodes,
                      //   "edges": [],
                      //   "backgroundUrl": localStorage.getItem("background")
                      // }
                      // that.add_Operation(newData, "updateNodeLevel")
                    },
                  },
                  {
                    text: that.languageData.forward,
                    callback(node) {
                      let nodeModel = lf.getNodeModelById(node.id);
                      nodeModel.setZIndex(nodeModel.zIndex + 1);
                      let data = nodeModel.getData();
                      let newNodes = [];
                      data.zIndex = nodeModel.zIndex + 1;
                      newNodes.push(data);
                      that.sendUpdate(newNodes, [], "update", 0);
                      // let newData = {
                      //   "nodes": newNodes,
                      //   "edges": [],
                      //   "backgroundUrl": localStorage.getItem("background")
                      // }
                      // that.add_Operation(newData, "updateNodeLevel")
                    },
                  },
                  {
                    text: that.languageData.backward,
                    callback(node) {
                      let nodeModel = lf.getNodeModelById(node.id);
                      nodeModel.setZIndex(nodeModel.zIndex - 1);
                      let data = nodeModel.getData();
                      let newNodes = [];
                      data.zIndex = nodeModel.zIndex - 1;
                      newNodes.push(data);
                      that.sendUpdate(newNodes, [], "update", 0);
                      // let newData = {
                      //   "nodes": newNodes,
                      //   "edges": [],
                      //   "backgroundUrl": localStorage.getItem("background")
                      // }
                      // that.add_Operation(newData, "updateNodeLevel")
                    },
                  },
                ], // 覆盖默认的节点右键菜单
          edgeMenu: [
            {
              text: that.languageData.delete,
              callback(edge) {
                that.isResizeNode = false;
                that.isDeleteNode = false;
                lf.deleteEdge(edge.id);
                let newEdge = [];
                newEdge.push(edge);
                that.sendUpdate([], newEdge, "delete", 0);
                let newData = {
                  nodes: [],
                  edges: newEdge,
                  backgroundUrl: localStorage.getItem("background"),
                };
                that.add_Operation(newData, "deleteEdge");
              },
            },
          ], // 删除默认的边右键菜单
          graphMenu: [
            // {
            //   text: that.languageData.beautifyAllNew,
            //   callback() {
            //     lf.extension.dagre && lf.extension.dagre.layout({
            //       nodesep: 20,
            //       ranksep: 20,
            //     });
            //   },
            // },
            {
              text: that.languageData.restore_background,
              callback() {
                localStorage.setItem("background", "");
                let newData = that.lf.getGraphData();
                newData.backgroundUrl = "";
                that.initLogicFlow(newData);
                // that.isAutomatic = false
                // that.lf.graphModel.graphDataToModel(newData)
                // that.lf.options.grid = newData.backgroundUrl != "" ? false : true
                // that.lf.options.background = {
                //   backgroundImage: 'url(' + newData.backgroundUrl + ')',
                //   backgroundRepeat: 'no-repeat',
                //   backgroundSize: 'cover',
                //   backgroundColor: '#F2F2F2'
                // };
                // that.lf.graphModel.partial = false
                // that.lf.render(that.lf.getGraphData())
                // that.lf.graphModel.partial = true
                that.sendUpdate([], [], "update", 0);
              },
            },
          ], // 覆盖默认的边右键菜单，与false表现一样
        });
        // 重置选区右键菜单
        lf.extension.menu.setMenuByType({
          type: "lf:defaultSelectionMenu",
          menu:
            that.group.length > 0
              ? [
                  {
                    text: that.languageData.delete,
                    callback() {
                      that
                        .$confirm(
                          that.languageData.tip18,
                          that.languageData.tip2,
                          {
                            confirmButtonText: that.languageData.confirm,
                            cancelButtonText: that.languageData.cancel,
                            type: "warning",
                          }
                        )
                        .then(() => {
                          const elements = lf.getSelectElements(true);
                          // lf.clearSelectElements();
                          let newNodes = [];
                          let newEdges = [];
                          if (
                            elements.nodes.length != 0 &&
                            elements.edges.length != 0
                          ) {
                            that.isDeleteNode = true;
                            elements.nodes.forEach((node) => {
                              newNodes.push(node);
                              lf.deleteNode(node.id);
                            });
                            elements.edges.forEach((edge) => {
                              newEdges.push(edge);
                              lf.deleteEdge(edge.id);
                            });
                            that.sendUpdate(newNodes, newEdges, "delete", 0);
                            that.isDeleteNode = false;
                            let newData = {
                              nodes: newNodes,
                              edges: newEdges,
                              backgroundUrl: localStorage.getItem("background"),
                            };
                            that.add_Operation(newData, "deleteNode");
                          }
                        })
                        .catch(() => {
                          // this.$message({
                          //   type: 'info',
                          //   message: '已取消删除'
                          // });
                        });
                    },
                  },
                  {
                    text: that.languageData.send,
                    callback() {
                      const elements = lf.getSelectElements(false);
                      lf.clearSelectElements();
                      that.sendNodes = [];
                      that.sendEdges = [];
                      let nodeIds = [];
                      if (elements.nodes.length != 0) {
                        that.isDeleteNode = true;
                        elements.nodes.forEach((node) => {
                          that.sendNodes.push(node);
                          nodeIds.push(node.id);
                        });
                      }
                      if (elements.edges.length != 0) {
                        elements.edges.forEach((edge) => {
                          if (
                            nodeIds.indexOf(edge.sourceNodeId) != -1 &&
                            nodeIds.indexOf(edge.targetNodeId) != -1
                          ) {
                            that.sendEdges.push(edge);
                          }
                        });
                      }
                      that.showSendDialogVisible = true;
                    },
                  },
                  // {
                  //   text: "选区美化",
                  //   callback() {
                  //     const elements = lf.getSelectElements(true);
                  //     lf.clearSelectElements();
                  //     lf.extension.selectDagre && lf.extension.selectDagre.layout({
                  //       nodesep: 80,
                  //       ranksep: 80,
                  //     }, elements);
                  //   }
                  // }
                ]
              : [
                  {
                    text: that.languageData.delete,
                    callback() {
                      that
                        .$confirm(
                          that.languageData.tip18,
                          that.languageData.tip2,
                          {
                            confirmButtonText: that.languageData.confirm,
                            cancelButtonText: that.languageData.cancel,
                            type: "warning",
                          }
                        )
                        .then(() => {
                          const elements = lf.getSelectElements(true);
                          // lf.clearSelectElements();
                          let newNodes = [];
                          let newEdges = [];
                          if (
                            elements.nodes.length != 0 &&
                            elements.edges.length != 0
                          ) {
                            that.isDeleteNode = true;
                            elements.nodes.forEach((node) => {
                              newNodes.push(node);
                              lf.deleteNode(node.id);
                            });
                            elements.edges.forEach((edge) => {
                              newEdges.push(edge);
                              lf.deleteEdge(edge.id);
                            });
                            that.sendUpdate(newNodes, newEdges, "delete", 0);
                            that.isDeleteNode = false;
                            let newData = {
                              nodes: newNodes,
                              edges: newEdges,
                              backgroundUrl: localStorage.getItem("background"),
                            };
                            that.add_Operation(newData, "deleteNode");
                          }
                        })
                        .catch(() => {
                          // this.$message({
                          //   type: 'info',
                          //   message: '已取消删除'
                          // });
                        });
                    },
                  },
                ],
        });
        lf.render(data);
      } else {
        // 重置右键菜单
        lf.extension.menu.setMenuConfig({
          nodeMenu: false,
          edgeMenu: false,
          graphMenu: [],
        });
        // 重置选区右键菜单
        lf.extension.menu.setMenuByType({
          type: "lf:defaultSelectionMenu",
          menu: [],
        });
        lf.render(data);
      }
    },
    getTransformSize(val) {
      this.transformSize = val;
    },
    sendUpdate(newNodes, newEdges, str, type) {
      let groupNew = this.group;
      let user_index = this.group[0].group_member.findIndex((item) => {
        return item.userid == this.user.userId;
      });
      if (user_index != -1) {
        groupNew[0].group_member[user_index].state = 2;
        this.$store.commit("set_group", []);
        this.$store.commit("set_group", groupNew);
      }
      if (this.network) {
        let mindinfo = {
          "us.cscl": [
            {
              sendId:
                window.location.href.indexOf("localhost") != -1 ||
                window.location.href.indexOf("192.168") != -1
                  ? "1cf9dc4b-d95f-11ea-af4c-52540005ab01"
                  : window.parent.US.userInfo.userid, //发送人id
              receiveId: localStorage.getItem("roomId"), //文件id
              pageId:
                window.location.href.indexOf("localhost") != -1 ||
                window.location.href.indexOf("192.168") != -1
                  ? "d7300d31-8cf6-38dc-e295-2c71622b4df1"
                  : window.parent.US.pageId,
              type: str, //消息类型
              messageInfo: {
                nodes: newNodes,
                edges: newEdges,
                backgroundUrl: localStorage.getItem("background"),
                userName:
                  window.location.href.indexOf("localhost") != -1 ||
                  window.location.href.indexOf("192.168") != -1
                    ? "潘炜桐"
                    : window.parent.US.userInfo.username,
                userId:
                  window.location.href.indexOf("localhost") != -1 ||
                  window.location.href.indexOf("192.168") != -1
                    ? "1cf9dc4b-d95f-11ea-af4c-52540005ab01"
                    : window.parent.US.userInfo.userid,
                roomId: localStorage.getItem("roomId"),
                type: type,
              },
            },
          ],
        };
        let params =
          "mode=" +
          [
            "send",
            encodeURIComponent(encodeURIComponent(JSON.stringify(mindinfo))),
          ].join(",");
        this.$ajax
          .post("https://poll.cocorobo.cn", params)
          .then(() => {
            //console.log(res);
          })
          .catch((err) => {
            console.error(err);
            if (str == "update") {
              let data = JSON.parse(localStorage.getItem("offlineUpdateData"));
              let index = [];
              if (newNodes.length != 0) {
                for (let i = 0; i < newNodes.length; i++) {
                  for (let j = 0; j < data.nodes.length; j++) {
                    if (newNodes[i].id == data.nodes[j].id) {
                      data.nodes[j] = newNodes[i];
                      index.push(j);
                      break;
                    }
                  }
                }
                if (index.length == 0) {
                  for (let j = 0; j < newNodes.length; j++) {
                    data.nodes.push(newNodes[j]);
                  }
                }
              }
              if (newEdges.length != 0) {
                for (let i = 0; i < newEdges.length; i++) {
                  for (let j = 0; j < data.edges.length; j++) {
                    if (newEdges[i].id == data.edges[j].id) {
                      data.edges[j] = newEdges[i];
                      index.push(j);
                      break;
                    }
                  }
                }
                if (index.length == 0) {
                  for (let j = 0; j < newEdges.length; j++) {
                    data.edges.push(newEdges[j]);
                  }
                }
              }
              if (data.backgroundUrl != localStorage.getItem("background")) {
                data.backgroundUrl = localStorage.getItem("background");
              }
              localStorage.setItem("offlineUpdateData", JSON.stringify(data));
            }
            if (str == "delete") {
              let data = JSON.parse(localStorage.getItem("offlineUpdateData"));
              if (newNodes.length != 0) {
                for (let i = 0; i < newNodes.length; i++) {
                  for (let j = 0; j < data.nodes.length; j++) {
                    if (newNodes[i].id == data.nodes[j].id) {
                      data.nodes.splice(j, 1);
                      break;
                    }
                  }
                }
              }
              if (newEdges.length != 0) {
                for (let i = 0; i < newEdges.length; i++) {
                  for (let j = 0; j < data.edges.length; j++) {
                    if (newEdges[i].id == data.edges[j].id) {
                      data.edges.splice(j, 1);
                      break;
                    }
                  }
                }
              }
              localStorage.setItem("offlineUpdateData", JSON.stringify(data));
              let offlineDeleteData = JSON.parse(
                localStorage.getItem("offlineDeleteData")
              );
              if (newNodes.length != 0) {
                for (let i = 0; i < newNodes.length; i++) {
                  offlineDeleteData.nodes.push(newNodes[i]);
                }
              }
              if (newEdges.length != 0) {
                for (let i = 0; i < newEdges.length; i++) {
                  offlineDeleteData.edges.push(newEdges[i]);
                }
              }
              localStorage.setItem(
                "offlineDeleteData",
                JSON.stringify(offlineDeleteData)
              );
            }
          });
      } else {
        if (str == "update") {
          let data = JSON.parse(localStorage.getItem("offlineUpdateData"));
          let index = [];
          if (newNodes.length != 0) {
            for (let i = 0; i < newNodes.length; i++) {
              for (let j = 0; j < data.nodes.length; j++) {
                if (newNodes[i].id == data.nodes[j].id) {
                  data.nodes[j] = newNodes[i];
                  index.push(j);
                  break;
                }
              }
            }
            if (index.length == 0) {
              for (let j = 0; j < newNodes.length; j++) {
                data.nodes.push(newNodes[j]);
              }
            }
          }
          if (newEdges.length != 0) {
            for (let i = 0; i < newEdges.length; i++) {
              for (let j = 0; j < data.edges.length; j++) {
                if (newEdges[i].id == data.edges[j].id) {
                  data.edges[j] = newEdges[i];
                  index.push(j);
                  break;
                }
              }
            }
            if (index.length == 0) {
              for (let j = 0; j < newEdges.length; j++) {
                data.edges.push(newEdges[j]);
              }
            }
          }
          if (data.backgroundUrl != localStorage.getItem("background")) {
            data.backgroundUrl = localStorage.getItem("background");
          }
          localStorage.setItem("offlineUpdateData", JSON.stringify(data));
        }
        if (str == "delete") {
          let data = JSON.parse(localStorage.getItem("offlineUpdateData"));
          if (newNodes.length != 0) {
            for (let i = 0; i < newNodes.length; i++) {
              for (let j = 0; j < data.nodes.length; j++) {
                if (newNodes[i].id == data.nodes[j].id) {
                  data.nodes.splice(j, 1);
                  break;
                }
              }
            }
          }
          if (newEdges.length != 0) {
            for (let i = 0; i < newEdges.length; i++) {
              for (let j = 0; j < data.edges.length; j++) {
                if (newEdges[i].id == data.edges[j].id) {
                  data.edges.splice(j, 1);
                  break;
                }
              }
            }
          }
          localStorage.setItem("offlineUpdateData", JSON.stringify(data));
          let offlineDeleteData = JSON.parse(
            localStorage.getItem("offlineDeleteData")
          );
          if (newNodes.length != 0) {
            for (let i = 0; i < newNodes.length; i++) {
              offlineDeleteData.nodes.push(newNodes[i]);
            }
          }
          if (newEdges.length != 0) {
            for (let i = 0; i < newEdges.length; i++) {
              offlineDeleteData.edges.push(newEdges[i]);
            }
          }
          localStorage.setItem(
            "offlineDeleteData",
            JSON.stringify(offlineDeleteData)
          );
        }
      }
    },
    /*
      数据-添加修改日志
    */
    add_Operation(data, str) {
      let newData = {
        type: str,
        data: data,
      };
      let that = this;
      let params =
        window.location.href.indexOf("localhost") != -1 ||
        window.location.href.indexOf("192.168") != -1
          ? "mode=" +
            [
              "1cf9dc4b-d95f-11ea-af4c-52540005ab01",
              localStorage.getItem("roomId"),
              "cscl",
              encodeURIComponent(encodeURIComponent(JSON.stringify(newData))),
            ].join(",")
          : "mode=" +
            [
              window.parent.US.userInfo.userid,
              localStorage.getItem("roomId"),
              "cscl",
              encodeURIComponent(encodeURIComponent(JSON.stringify(newData))),
            ].join(",");
      that.$ajax
        .post("https://pbl.cocorobo.cn/api/pbl/add_OperationCSCL", params)
        .then(() => {})
        .catch((err) => {
          console.error(err);
        });
    },
    initLogicFlow(data) {
      const that = this;
      // 引入框选插件
      LogicFlow.use(SelectionSelect);
      LogicFlow.use(Snapshot);
      LogicFlow.use(DynamicGroup);
      LogicFlow.use(DndPanel);
      LogicFlow.use(BpmnElement);
      LogicFlow.use(MiniMap);
      LogicFlow.use(Menu);
      LogicFlow.use(Dagre);
      LogicFlow.use(SelectDagre);
      const backGround = data.backgroundUrl;
      const lf = new LogicFlow({
        container: this.$refs.diagram,
        overlapMode: 1,
        autoExpand: false,
        metaKeyMultipleSelected: true,
        pluginsOptions: {
          MiniMap: {
            showEdge: false,
            isShowHeader: false,
            isShowCloseIcon: false,
            leftPosition: "83%",
            topPosition: "7%",
            rightPosition: undefined,
            bottomPosition: undefined,
            headerTitle: this.languageData.minimap,
          }
        },
        // grid: {
        //   visible: false,
        //   size: 5
        // },
        grid: {
          visible: backGround != "" ? false : true,
          size: 20,
          type: "dot",
          config: {
            color: "#ababab",
            thickness: 1,
          },
        },
        // grid: backGround != "" ? false : true,
        partial: true,
        // background: {
        //   backgroundImage: 'url(' + backGround + ')',
        //   backgroundRepeat: 'no-repeat',
        //   backgroundSize: 'cover',
        //   backgroundColor: backGround != "" ? '#F2F2F2' : '#FFFFFF'
        // },
        isSilentMode: false,
        adjustNodePosition: false,
        adjustEdge: false,
        adjustEdgeStartAndEnd: false,
      });
      lf.setTheme({
        baseEdge: { strokeWidth: 1 },
        baseNode: { strokeWidth: 1 },
        nodeText: { overflowMode: "autoWrap", lineHeight: 1.5 },
        edgeText: { overflowMode: "autoWrap", lineHeight: 1.5 },
        // outline: {
        //   fill: "transparent",
        //   stroke: "#007BFF",
        //   strokeDasharray: "3,3",
        //   strokeWidth: 2,
        //   hover: {
        //     stroke: "#007BFF",
        //     strokeWidth: 2,
        //   },
        // }
      });
      // 重置右键菜单
      lf.extension.menu.setMenuConfig({
        nodeMenu: false,
        edgeMenu: false,
        graphMenu: [],
      });
      // 重置选区右键菜单
      lf.extension.menu.setMenuByType({
        type: "lf:defaultSelectionMenu",
        menu: [],
      });
      // 注册自定义元素
      registerCustomElement(lf);
      lf.setDefaultEdgeType("pro-line");

      // let nodeIds = []
      // for (let i = 0; i < data.nodes.length; i++) {
      //   nodeIds.push(data.nodes[i].id)
      // }
      // let edges = []
      // for (let i = 0; i < data.edges.length; i++) {
      //   if (nodeIds.indexOf(data.edges[i].sourceNodeId) != -1 && nodeIds.indexOf(data.edges[i].targetNodeId) != -1) {
      //     edges.push(data.edges[i])
      //   }
      // }
      // data.edges = edges

      let nodes = [];
      let sprites = [];
      let nodesNew = []

      let groupIndex = data.nodes.findIndex(item => item.type === "my-group")

      // const { transformModel } = lf.graphModel;
      // const point = transformModel.HtmlPointToCanvasPoint([75.5, 36]);

      // let point =  lf.graphModel.getPointByClient({ x: 75.5, y: 36 });
      // console.log(point)

      if (data.nodes && data.nodes.length != 0) {
        //   if (window.location.href.indexOf("localhost") != -1 || window.location.href.indexOf("192.168") != -1) {
        //     for(let i = 0; i < data.nodes.length; i++) {
        //       data.nodes[i].x = data.nodes[i].x
        //       nodesNew.push(data.nodes[i])
        //     }
        //     data.nodes = nodesNew
        //   }
        //   else {
        //     for(let i = 0; i < data.nodes.length; i++) {
        //       data.nodes[i].x = data.nodes[i].x - (point.canvasOverlayPosition.x * 2)
        //       data.nodes[i].y = data.nodes[i].y - (point.canvasOverlayPosition.y * 2)
        //       nodesNew.push(data.nodes[i])
        //     }
        //     data.nodes = nodesNew
        //   }

        if(groupIndex != -1) {
          let min_node_x = find_min_x(data.nodes)
          let min_node_y = find_min_y(data.nodes)

          let left_min_node_x = 0
          let top_min_node_y = 0

          if (min_node_x.type == "icon-theme" || min_node_x.type == "icon-stage" || min_node_x.type == "icon-task" || min_node_x.type == "icon-card" || min_node_x.type == "icon-AI" || min_node_x.type == "icon-thinking" || min_node_x.type == "icon-markdown") {
            if(min_node_x.properties.width) {
              left_min_node_x = min_node_x.x - min_node_x.properties.width
            }
            else {
              left_min_node_x = min_node_x.x - 250
            }
          } else if(min_node_x.type == "my-group") {
            if(min_node_x.properties.width) {
              left_min_node_x = min_node_x.x - min_node_x.properties.width
            }
            else {
              left_min_node_x = min_node_x.x - 1000
            }
          } else {
            if(min_node_x.properties.width) {
              left_min_node_x = min_node_x.x - min_node_x.properties.width
            }
            else {
              left_min_node_x = min_node_x.x - 265
            }
          }

          if (min_node_y.type == "icon-theme" || min_node_y.type == "icon-stage" || min_node_y.type == "icon-task") {
            if(min_node_y.properties.height) {
              top_min_node_y = min_node_y.y - min_node_y.properties.height
            }
            else {
              top_min_node_y = min_node_y.y - 75
            }
          } else if(min_node_y.type == "my-group") {
            if(min_node_y.properties.height) {
              top_min_node_y = min_node_y.y - min_node_y.properties.height
            }
            else {
              top_min_node_y = min_node_y.y - 600
            }
          } else {
            if(min_node_y.properties.height) {
              top_min_node_y = min_node_y.y - min_node_y.properties.height
            }
            else {
              top_min_node_y = min_node_y.y - 250
            }
          }
  
          if (left_min_node_x < 0 && top_min_node_y < 0) {
            let change_nodes = []
            let change_edges = []
            for (let i = 0; i < data.nodes.length; i++) {
              data.nodes[i].x = data.nodes[i].x - left_min_node_x 
              data.nodes[i].y = data.nodes[i].y - top_min_node_y
              change_nodes.push(data.nodes[i]);
            }
            for (let i = 0; i < data.edges.length; i++) {
              data.edges[i].startPoint.x = data.edges[i].startPoint.x - left_min_node_x
              data.edges[i].endPoint.x = data.edges[i].endPoint.x - left_min_node_x
              data.edges[i].startPoint.y = data.edges[i].startPoint.y - top_min_node_y
              data.edges[i].endPoint.y = data.edges[i].endPoint.y - top_min_node_y
              change_edges.push(data.edges[i]);
            }
            data.nodes = change_nodes;
            data.edges = change_edges
          } else if (left_min_node_x < 0 && top_min_node_y > 0) {
            let change_nodes = []
            let change_edges = []
            for (let i = 0; i < data.nodes.length; i++) {
              data.nodes[i].x = data.nodes[i].x - left_min_node_x 
              change_nodes.push(data.nodes[i]);
            }
            for (let i = 0; i < data.edges.length; i++) {
              data.edges[i].startPoint.x = data.edges[i].startPoint.x - left_min_node_x
              data.edges[i].endPoint.x = data.edges[i].endPoint.x - left_min_node_x
              change_edges.push(data.edges[i]);
            }
            data.nodes = change_nodes;
            data.edges = change_edges
          } else if (left_min_node_x > 0 && top_min_node_y < 0) {
            let change_nodes = []
            let change_edges = []
            for (let i = 0; i < data.nodes.length; i++) {
              data.nodes[i].y = data.nodes[i].y - top_min_node_y
              change_nodes.push(data.nodes[i]);
            }
            for (let i = 0; i < data.edges.length; i++) {
              data.edges[i].startPoint.y = data.edges[i].startPoint.y - top_min_node_y
              data.edges[i].endPoint.y = data.edges[i].endPoint.y - top_min_node_y
              change_edges.push(data.edges[i]);
            }
            data.nodes = change_nodes;
            data.edges = change_edges
          }

          for (let i = 0; i < data.nodes.length; i++) {
            if (data.nodes[i].type.indexOf("my-group") == -1) {
              sprites.push(data.nodes[i]);
            }
          }
          for (let i = 0; i < data.nodes.length; i++) {
            if (data.nodes[i].type.indexOf("my-group") != -1) {
              nodesNew.push(data.nodes[i]);
            }
          }
        }
        else {
          sprites = data.nodes;
        }
      }
      for (let i = 0; i < data.nodes.length; i++) {
        if (
          data.nodes[i].type.indexOf("icon-pm") == -1 &&
          data.nodes[i].type.indexOf("icon-st-") == -1 &&
          data.nodes[i].type.indexOf("my-group") == -1
        ) {
          nodes.push(data.nodes[i]);
        }
      }
      data.nodes = nodes;

      try {
        this.isExistError = false;
        lf.render(data);
      } catch {
        this.$message({
          duration: 0,
          showClose: true,
          offset: 40,
          type: "warning",
          message: this.languageData.errorTip,
        });
        this.isExistError = true;
        lf.render(data);
      }

      for (let i = 0; i < data.edges.length; i++) {
        lf.graphModel.getEdgeModelById(data.edges[i].id).setProperties(data.edges[i].properties);
        if (data.edges[i].pointsList) {
          lf.graphModel
            .getEdgeModelById(data.edges[i].id)
            .updateStartPoint(data.edges[i].startPoint);
          lf.graphModel
            .getEdgeModelById(data.edges[i].id)
            .updateEndPoint(data.edges[i].endPoint);
          lf.graphModel.getEdgeModelById(data.edges[i].id).pointsList =
            data.edges[i].pointsList;
          lf.graphModel.getEdgeModelById(data.edges[i].id).initPoints();
          lf.graphModel.updateAttributes(data.edges[i].id, {
            isHitable: false,
            draggable: false,
            type: data.edges[i].type,
            zIndex: data.edges[i].zIndex,
          });
        } else {
          lf.graphModel.updateAttributes(data.edges[i].id, {
            // isSelected: true,
            isHitable: false,
            draggable: false,
            type: data.edges[i].type,
            startPoint: data.edges[i].startPoint,
            endPoint: data.edges[i].endPoint,
            zIndex: data.edges[i].zIndex,
          });
        }
      }

      window.showDialog = function (node) {
        if (
          Object.prototype.hasOwnProperty.call(node, "type") &&
          !that.showDialogVisible
        ) {
          that.showList = [node];
          that.showDialogVisible = true;
          that.Show = false;
          setTimeout(function () {
            that.Show = true;
          }, 100);
        }
      };

      window.moveAndZoom = function () {
        let newScale = that.transformSize;
        if (newScale != 100) {
          that.lf.zoom(1);
        }
      };

      window.selectOnNode = function (node) {
        lf.selectElementById(node.id);
      };

      window.focusOnNode = function (x, y) {
        const { transformModel, width, height } = lf.graphModel;
        transformModel.focusOn(x, y, width, height);
      };

      window.clearSelectElements = function () {
        lf.clearSelectElements();
      };

      window.getDevice = function () {
        return that.isPhone;
      };

      if (data.nodes && data.nodes.length != 0) {
        initStateNew();
        if (groupIndex != -1) {
          addSpriteNew(sprites, nodesNew);
        }
        else {
          addSprite(sprites, backGround);
        }
      }

      // for(let i = 0;i < data.nodes.length;i++) {
      //   if(data.nodes[i].type == "icon-theme") {
      //     const { transformModel } = lf.graphModel;
      //     // this.lf.focusOn({
      //     //   id: data.nodes[i].id,
      //     //   // coordinate: {
      //     //   //   x: Math.round(data.nodes[i].x),
      //     //   //   y: Math.round(data.nodes[i].y),
      //     //   // }
      //     // });
      //     transformModel.focusOn(Math.round(data.nodes[i].x),Math.round(data.nodes[i].y),Math.round(window.screen.width), Math.round(window.screen.height))
      //     break
      //   }
      // }

      // if (data.edges && data.edges.length != 0) {
      //   let newEdges = [];
      //   for (let i = 0; i < data.edges.length; i++) {
      //     if (data.edges[i].type.indexOf("pro-dashed") != -1) {
      //       if (data.edges[i].type == "pro-dashed-bezier") {
      //         lf.graphModel.changeEdgeType(data.edges[i].id, "pro-bezier");
      //         data.edges[i].type = "pro-bezier";
      //         newEdges.push(data.edges[i]);
      //       }
      //       if (data.edges[i].type == "pro-dashed-curved") {
      //         lf.graphModel.changeEdgeType(data.edges[i].id, "pro-curved");
      //         data.edges[i].type = "pro-curved";
      //         newEdges.push(data.edges[i]);
      //       }
      //       if (data.edges[i].type == "pro-dashed-line") {
      //         lf.graphModel.changeEdgeType(data.edges[i].id, "pro-line");
      //         data.edges[i].type = "pro-line";
      //         newEdges.push(data.edges[i]);
      //       }
      //       if (data.edges[i].type == "pro-dashed-polyline") {
      //         lf.graphModel.changeEdgeType(data.edges[i].id, "pro-polyline");
      //         data.edges[i].type = "pro-polyline";
      //         newEdges.push(data.edges[i]);
      //       }
      //     }
      //   }
      //   if (newEdges.length != 0) {
      //     this.sendUpdate([], newEdges, "update", 0);
      //   }
      // }

      for (let i = 0; i < data.nodes.length; i++) {
        lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
          isShowDelete: false,
        });
      }

      lf.clearSelectElements();
      lf.setZoomMiniSize(0.2);
      lf.setZoomMaxSize(20);

      lf.extension.snapshot.useGlobalRules = false;
      lf.extension.snapshot.customCssRules = `
        .lf-node-text-auto-wrap-content{
          line-height: 1.2;
          background: transparent;
          text-align: center;
          word-break: break-all;
          width: 100%;
        }
        .lf-canvas-overlay {
          background: #ffffff;
        }
        .uml-wrapper {
          background: #FFFFFF;
          width: 100%;
          height: 100%;
          border-radius: 8px;
          box-sizing: border-box;
          position: relative;
          box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.12), 0px 4px 5px 0px rgba(0, 0, 0, 0.08), 0px 1px 10px 0px rgba(0, 0, 0, 0.05);
          /* box-shadow: rgba(0, 0, 0, 0.16) 0px 0px 10px 1px; */
          /* filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.12)) drop-shadow(0px 4px 5px rgba(0, 0, 0, 0.08)) drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.05)); */
        }
        .is_show_user {
          display: flex;
          flex-direction: row;
          height: 27px;
          line-height: 27px;
        }
        .el-icon-circle-close {
          font-family: element-icons!important;
          speak: none;
          font-style: normal;
          font-weight: 400;
          font-variant: normal;
          text-transform: none;
          line-height: 1;
          vertical-align: baseline;
          display: inline-block;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }
        .closeImgTheme {
          font-size: 20px;
          position: absolute;
          top: 3px;
          right: 3px;
          cursor: pointer;
          color: #000000;
        }
        .uml-select-body {
          /* border-top: 1px solid #838382; */
          /* border-bottom: 1px solid #838382; */
          padding: 0px 20px 5px 20px;
          font-size: 14px;
          font-family: SimSun;
          font-weight: bold;
          text-align: center;
          /* font-family: "Microsoft YaHei"; */
          word-break: break-all;
          text-overflow: ellipsis;
          /* display: -webkit-box; */
          /* -webkit-box-orient: vertical; */
          /* -webkit-line-clamp: 5; */
          overflow: hidden;
          word-wrap: break-word;
          height: 70%;
        }
        .el-input {
          position: relative;
          font-size: 14px;
          display: inline-block;
        }
      `;

      this.lf = lf;
      // this.$nextTick(() => {
      //   const d = this.lf.getGraphData()
      //   let _this = this;
      //   for (let i = 0; i < d.nodes.length; i++) {
      //     if (d.nodes[i].type == "my-group") {
      //       $("#fold_" + d.nodes[i].id).on("click", function (e) {
      //         e.stopPropagation();
      //         const groupModel = lf.getNodeModelById(d.nodes[i].id);
      //         groupModel.foldGroup(!groupModel.isFolded);
      //         _this.$_setStyle({
      //           isAlFolded: !groupModel.isFolded
      //         })
      //       })
      //     }
      //   }
      // })
      // 监听选中选区,点击节点,点击画布
      this.lf.on("selection:selected,node:click,blank:click", ({ e }) => {
        this.$nextTick(() => {
          if (!this.lf.getEditConfig().isSilentMode) {
            const { nodes, edges } = this.lf.getSelectElements();
            if (nodes.length != 0) {
              // this.$set(this, 'activeNodes', nodes)
              this.activeEdges = [];
              this.activeNodes = [];
              // this.$_getProperty()
              localStorage.setItem("type", nodes[0].type);
              // let data = this.lf.getGraphData()
              // for (let i = 0; i < data.nodes.length; i++) {
              //   this.lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
              //     isShowDelete: false
              //   });
              // }
              // this.lf.graphModel.getNodeModelById(nodes[0].id).setProperties({
              //   isShowDelete: true
              // });
            }
            // if (this.activeNodes.length != 0) {
            //   localStorage.setItem("type", this.activeNodes[0].type);
            //   // const edgeData = this.lf.graphModel.getNodeIncomingEdge(this.activeNodes[0].id)
            //   // let arr = [];
            //   // for (let i = 0; i < edgeData.length; i++) {
            //   //   arr.push({ "id": edgeData[i].sourceNodeId, "route": edgeData[i].properties.route })
            //   // }
            //   // localStorage.setItem("edges", JSON.stringify(arr))
            //   let data = this.lf.getGraphData()
            //   for (let i = 0; i < data.nodes.length; i++) {
            //     this.lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
            //       isShowDelete: false
            //     });
            //   }
            //   this.lf.graphModel.getNodeModelById(this.activeNodes[0].id).setProperties({
            //     isShowDelete: true
            //   });
            //   // if (this.activeNodes[0].properties.width && this.activeNodes[0].properties.height) {
            //   //   this.$_setStyle({
            //   //     id: this.activeNodes[0].id,
            //   //     type: this.activeNodes[0].type,
            //   //     width: this.activeNodes[0].properties.width,
            //   //     height: this.activeNodes[0].properties.height
            //   //   })
            //   // }
            //   // if (this.activeNodes[0].properties.nodeSize && this.activeNodes[0].properties.nodeSize.width && this.activeNodes[0].properties.nodeSize.height) {
            //   //   this.$_setStyle({
            //   //     id: this.activeNodes[0].id,
            //   //     type: this.activeNodes[0].type,
            //   //     width: this.activeNodes[0].properties.nodeSize.width,
            //   //     height: this.activeNodes[0].properties.nodeSize.height
            //   //   })
            //   // }
            //   // else {
            //   //   this.$_setStyle({
            //   //     id: this.activeNodes[0].id,
            //   //     type: this.activeNodes[0].type,
            //   //   })
            //   // }
            //   // this.iconList = this.activeNodes[0].properties.iconList
            //   // this.imageList = this.activeNodes[0].properties.imageList
            //   // this.videoList = this.activeNodes[0].properties.videoList
            //   // this.audioList = this.activeNodes[0].properties.audioList
            //   // this.fileList = this.activeNodes[0].properties.fileList
            // }
            else {
              if (this.newDataAll.nodes != null) {
                this.$confirm(this.languageData.tip24, this.languageData.tip2, {
                  confirmButtonText: this.languageData.confirm,
                  cancelButtonText: this.languageData.cancel,
                  type: "warning",
                })
                  .then(() => {
                    let x = e.clientX;
                    let y = e.clientY;
                    let position = this.lf.graphModel.getPointByClient({
                      x,
                      y,
                    });
                    //console.log(position.canvasOverlayPosition)
                    let data = this.lf.getGraphData();
                    let newDataAll = this.newDataAll;
                    if (data.nodes && data.nodes.length != 0) {
                      let max_node_old = find_max_x(data.nodes);
                      let min_node_old = find_min_x(data.nodes);
                      if (
                        position.canvasOverlayPosition.x >=
                        max_node_old.x + 132.5
                      ) {
                        let min_node = find_min_x(newDataAll.nodes);
                        let min_node_x = min_node.x;
                        let replace_x = parseInt(
                          position.canvasOverlayPosition.x
                        );
                        let a = 132.5;
                        if (
                          min_node.properties.nodeSize &&
                          min_node.properties.nodeSize.width
                        ) {
                          a = min_node.properties.nodeSize.width / 2;
                        }
                        // else if (min_node.properties.width) {
                        //   a = min_node.properties.width / 2
                        // }
                        newDataAll = replace_all_x(
                          newDataAll,
                          replace_x,
                          min_node_x,
                          a
                        );
                      } else if (
                        position.canvasOverlayPosition.x <=
                        min_node_old.x - 132.5
                      ) {
                        let max_node = find_max_x(newDataAll.nodes);
                        let max_node_x = max_node.x;
                        let replace_x = parseInt(
                          position.canvasOverlayPosition.x
                        );
                        let a = 132.5;
                        if (
                          max_node.properties.nodeSize &&
                          max_node.properties.nodeSize.width
                        ) {
                          a = max_node.properties.nodeSize.width / 2;
                        }
                        // else if (max_node.properties.width) {
                        //   a = max_node.properties.width / 2
                        // }
                        newDataAll = replace_all_x(
                          newDataAll,
                          replace_x,
                          max_node_x,
                          a
                        );
                      } else if (
                        min_node_old.x - 132.5 <
                        position.canvasOverlayPosition.x <
                        max_node_old.x + 132.5
                      ) {
                        let max_node = find_max_y(newDataAll.nodes);
                        let max_node_y = max_node.y + 132.5;
                        let min_node = find_min_y(data.nodes);
                        let min_node_y = min_node.y - 132.5;
                        let replace_y = min_node_y;
                        let a = 132.5;
                        if (
                          max_node.properties.nodeSize &&
                          max_node.properties.nodeSize.height
                        ) {
                          a = max_node.properties.nodeSize.height / 2;
                        }
                        newDataAll = replace_all_y(
                          newDataAll,
                          replace_y,
                          max_node_y,
                          a
                        );
                      }
                    }
                    let nodes = newDataAll.nodes;
                    let edges = newDataAll.edges;
                    let focusNode = nodes[0];
                    for (let i = 0; i < nodes.length; i++) {
                      if (nodes[i].type == "icon-theme") {
                        focusNode = nodes[i];
                      }
                      data.nodes.push(nodes[i]);
                      // that.lf.graphModel.addNode(res.data.nodes[i]);
                    }
                    for (let i = 0; i < edges.length; i++) {
                      edges[i].zIndex = 1;
                      data.edges.push(edges[i]);
                      // that.lf.graphModel.addEdge(res.data.edges[i]);
                    }
                    data.backgroundUrl = newDataAll.backgroundUrl;
                    localStorage.setItem(
                      "background",
                      newDataAll.backgroundUrl
                    );
                    // this.lf.addElements({
                    //   "nodes": nodes,
                    //   "edges": edges
                    // })
                    this.lf.graphModel.graphDataToModel(data);
                    // this.lf.options.grid = data.backgroundUrl != "" ? false : true
                    // this.lf.options.background = {
                    //   backgroundImage: 'url(' + data.backgroundUrl + ')',
                    //   backgroundRepeat: 'no-repeat',
                    //   backgroundSize: 'cover',
                    //   backgroundColor: '#F2F2F2'
                    // };
                    console.log(data);
                    let newData = {
                      nodes: nodes,
                      edges: edges,
                      backgroundUrl: data.backgroundUrl,
                    };
                    // this.lf.graphModel.partial = false
                    // this.lf.render(this.lf.getGraphData())
                    // this.lf.graphModel.partial = true
                    this.initLogicFlow(data);
                    this.sendUpdate(newData.nodes, newData.edges, "update", 0);
                    this.add_Operation(newData, "addNode");
                    // that.$parent.lf.extension.dagre && that.$parent.lf.extension.dagre.layout({
                    //   nodesep: 20,
                    //   ranksep: 20,
                    // });
                    this.lf.focusOn({
                      id: focusNode.id,
                    });
                    this.newDataAll = {};
                    $(".lf-drag-able").removeClass(this.className);
                  })
                  .catch(() => {
                    // this.$message({
                    //   type: 'info',
                    //   message: '已取消删除'
                    // });
                    this.newDataAll = {};
                    $(".lf-drag-able").removeClass(this.className);
                  });
              }
              this.isPromptsList = false;
              if (this.isJobReception) {
                this.isHidden = true;
              }
              this.lf.clearSelectElements();
              this.activeEdges = edges;
              this.activeNodes = nodes;
              let data = this.lf.getGraphData();
              for (let i = 0; i < data.nodes.length; i++) {
                // if (data.nodes[i].properties.width && data.nodes[i].properties.height) {
                //   this.lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
                //     width: data.nodes[i].properties.width,
                //     height: data.nodes[i].properties.height,
                //     isShowDelete: false
                //   });
                // }
                if (
                  data.nodes[i].properties.nodeSize &&
                  data.nodes[i].properties.nodeSize.width &&
                  data.nodes[i].properties.nodeSize.height
                ) {
                  this.lf.graphModel
                    .getNodeModelById(data.nodes[i].id)
                    .setProperties({
                      width: data.nodes[i].properties.nodeSize.width,
                      height: data.nodes[i].properties.nodeSize.height,
                      isShowDelete: false,
                    });
                } else {
                  this.lf.graphModel
                    .getNodeModelById(data.nodes[i].id)
                    .setProperties({
                      isShowDelete: false,
                    });
                }
                if (
                  data.nodes[i].type == "icon-theme" ||
                  (data.nodes[i].type == "icon-stage" &&
                    !data.nodes[i].properties.stageContent) ||
                  (data.nodes[i].type == "icon-stage" &&
                    data.nodes[i].properties.stageContent &&
                    data.nodes[i].properties.stageContent == "<p></p>") ||
                  (data.nodes[i].type == "icon-task" &&
                    !data.nodes[i].properties.taskContent) ||
                  (data.nodes[i].type == "icon-task" &&
                    data.nodes[i].properties.taskContent &&
                    data.nodes[i].properties.taskContent == "<p></p>") ||
                  (data.nodes[i].type == "icon-homework" &&
                    !data.nodes[i].properties.homeworkContent) ||
                  (data.nodes[i].type == "icon-homework" &&
                    data.nodes[i].properties.homeworkContent &&
                    data.nodes[i].properties.homeworkContent == "<p></p>")
                ) {
                  // $("#input_" + data.nodes[i].id).attr("disabled", true)
                  $("#text_" + data.nodes[i].id).css("display", "block");
                  $("#input_" + data.nodes[i].id).css("display", "none");
                }
              }
            }
          } else {
            this.lf.clearSelectElements();
            let data = this.lf.getGraphData();
            for (let i = 0; i < data.nodes.length; i++) {
              // if (data.nodes[i].properties.width && data.nodes[i].properties.height) {
              //   this.lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
              //     width: data.nodes[i].properties.width,
              //     height: data.nodes[i].properties.height,
              //     isShowDelete: false
              //   });
              // }
              if (
                data.nodes[i].properties.nodeSize &&
                data.nodes[i].properties.nodeSize.width &&
                data.nodes[i].properties.nodeSize.height
              ) {
                this.lf.graphModel
                  .getNodeModelById(data.nodes[i].id)
                  .setProperties({
                    width: data.nodes[i].properties.nodeSize.width,
                    height: data.nodes[i].properties.nodeSize.height,
                    isShowDelete: false,
                  });
              } else {
                this.lf.graphModel
                  .getNodeModelById(data.nodes[i].id)
                  .setProperties({
                    isShowDelete: false,
                  });
              }
            }
          }
        });
      });

      // 监听双击节点
      this.lf.on("node:dbclick", () => {
        this.$nextTick(() => {
          if (!this.lf.getEditConfig().isSilentMode) {
            const { nodes } = this.lf.getSelectElements();
            this.lf.clearSelectElements();
            this.activeNodes = [];
            this.showList = nodes;
            this.showDialogVisible = true;
            that.Show = false;
            setTimeout(function () {
              that.Show = true;
            }, 100);
            console.log(nodes);
            // if (nodes[0].type == 'icon-theme' || ((nodes[0].type == 'icon-stage' && !nodes[0].properties.stageContent) || (nodes[0].type == 'icon-stage' && nodes[0].properties.stageContent && nodes[0].properties.stageContent == "<p></p>")) || ((nodes[0].type == 'icon-task' && !nodes[0].properties.taskContent) || (nodes[0].type == 'icon-task' && nodes[0].properties.taskContent && nodes[0].properties.taskContent == "<p></p>")) || ((nodes[0].type == 'icon-homework' && !nodes[0].properties.homeworkContent) || (nodes[0].type == 'icon-homework' && nodes[0].properties.homeworkContent && nodes[0].properties.homeworkContent == "<p></p>"))) {
            //   // $("#input_" + nodes[0].id).attr("disabled", false)
            //   $("#text_" + nodes[0].id).css("display", "none")
            //   $("#input_" + nodes[0].id).css("display", "block")
            //   // $("#input_" + nodes[0].id).focus()
            //   var sr = document.getElementById("input_" + nodes[0].id);
            //   var len = sr.value.length;
            //   this.setSelectionRange(sr, len, len);
            // }
            // let isShowResource = false
            // if((nodes.length != 0 && nodes[0].type == 'icon-card' && nodes[0].properties.radio == "content" && nodes[0].properties.content && nodes[0].properties.content != "<p></p>") ||
            // (nodes.length != 0 && nodes[0].type == 'icon-card' && nodes[0].properties.radio == "iframeUrl" && nodes[0].properties.iframeUrl && nodes[0].properties.iframeUrl != "") ||
            // (nodes.length != 0 && nodes[0].type == 'icon-card' && nodes[0].properties.radio == "embedCode" && nodes[0].properties.embedCode && nodes[0].properties.embedCode != "") ||
            // (nodes.length != 0 && nodes[0].type == 'icon-card' && nodes[0].properties.radio == "imageList" && nodes[0].properties.imageList && nodes[0].properties.imageList.length != 0) ||
            // (nodes.length != 0 && nodes[0].type == 'icon-card' && nodes[0].properties.radio == "videoList" && nodes[0].properties.videoList && nodes[0].properties.videoList.length != 0) ||
            // (nodes.length != 0 && nodes[0].type == 'icon-card' && nodes[0].properties.radio == "audioList" && nodes[0].properties.audioList && nodes[0].properties.audioList.length != 0) ||
            // (nodes.length != 0 && nodes[0].type == 'icon-card' && nodes[0].properties.radio == "fileList" && nodes[0].properties.fileList && nodes[0].properties.fileList.length != 0)) {
            //   isShowResource = true
            // }
            // if (nodes[0].type == "icon-thinking") {
            //   this.showDialogVisible = false
            //   this.showThinkingDialogVisible = true
            // }
            // if (nodes[0].type == "icon-whiteboard") {
            //   this.showDialogVisible = false
            //   this.showWhiteboardDialogVisible = true
            // }
            // if (nodes[0].type == "icon-map") {
            //   this.showDialogVisible = false
            //   this.showMapDialogVisible = true
            // }
            // if (nodes[0].type == "icon-camera") {
            //   this.showDialogVisible = false
            //   this.showCameraDialog = true
            // }
            // if (Object.keys(nodes[0].properties).length > 3 && nodes[0].type != 'icon-thinking' && nodes[0].type != 'icon-whiteboard' && nodes[0].type != 'icon-map' && nodes[0].type != 'icon-camera') {
            //   // this.showDialogVisible = (nodes.length != 0 && nodes[0].type != 'my-group' && nodes[0].type != 'icon-start' && nodes[0].type != 'icon-theme' && nodes[0].type != 'icon-stage') ? true : false
            //   if (nodes.length != 0 && nodes[0].type != 'my-group' && nodes[0].type != 'icon-start' && nodes[0].type != 'icon-theme' && nodes[0].type != 'icon-stage' && nodes[0].type != 'icon-task' && nodes[0].type != 'icon-homework' && nodes[0].type != 'icon-card') {
            //     this.showDialogVisible = true
            //   }
            //   else if ((nodes.length != 0 && nodes[0].type == 'icon-task' && nodes[0].properties.taskContent && nodes[0].properties.taskContent != "<p></p>") || (nodes.length != 0 && nodes[0].type == 'icon-stage' && nodes[0].properties.stageContent && nodes[0].properties.stageContent != "<p></p>") || (nodes.length != 0 && nodes[0].type == 'icon-homework' && nodes[0].properties.homeworkContent && nodes[0].properties.homeworkContent != "<p></p>") || isShowResource) {
            //     this.showDialogVisible = true
            //   }
            //   else {
            //     this.showDialogVisible = false
            //   }
            // }
          } else {
            this.lf.clearSelectElements();
          }
        });
        // this.$nextTick(() => {
        //   if (!(this.lf.getEditConfig().isSilentMode)) {
        //     const { nodes, edges } = this.lf.getSelectElements()
        //     this.$set(this, 'activeNodes', nodes)
        //     this.activeEdges = edges
        //     this.activeNodes = nodes
        //     this.$_getProperty()
        //     this.isShowGroup = false
        //     if(e?.type=="click"){
        //       this.last_node_id = nodes[0].id
        //     }
        //     if (nodes[0].type == "icon-thinking") {
        //       this.lf.clearSelectElements()
        //       this.activeNodes = []
        //       this.showList = nodes
        //       this.showDialogVisible = false
        //       this.showThinkingDialogVisible = true
        //       this.lf.graphModel.getNodeModelById(nodes[0].id).setProperties({
        //         isShowDelete: false
        //       });
        //     }
        //     else if (nodes[0].type == "icon-whiteboard") {
        //       this.lf.clearSelectElements()
        //       this.activeNodes = []
        //       this.showList = nodes
        //       this.showDialogVisible = false
        //       this.showWhiteboardDialogVisible = true
        //       this.lf.graphModel.getNodeModelById(nodes[0].id).setProperties({
        //         isShowDelete: false
        //       });
        //     }
        //     else if (nodes[0].type == "icon-map") {
        //       this.lf.clearSelectElements()
        //       this.activeNodes = []
        //       this.showList = nodes
        //       this.showDialogVisible = false
        //       this.showMapDialogVisible = true
        //       this.lf.graphModel.getNodeModelById(nodes[0].id).setProperties({
        //         isShowDelete: false
        //       });
        //     }
        //     else if (nodes[0].type == "icon-camera") {
        //       this.lf.clearSelectElements()
        //       this.activeNodes = []
        //       this.showList = nodes
        //       this.showDialogVisible = false
        //       this.showCameraDialog = true
        //       this.lf.graphModel.getNodeModelById(nodes[0].id).setProperties({
        //         isShowDelete: false
        //       });
        //     }
        //     else {
        //       if (this.activeNodes.length != 0) {
        //         localStorage.setItem("type", this.activeNodes[0].type);
        //         // const edgeData = this.lf.graphModel.getNodeIncomingEdge(this.activeNodes[0].id)
        //         // let arr = [];
        //         // for (let i = 0; i < edgeData.length; i++) {
        //         //   arr.push({ "id": edgeData[i].sourceNodeId, "route": edgeData[i].properties.route })
        //         // }
        //         // localStorage.setItem("edges", JSON.stringify(arr))
        //         let data = this.lf.getGraphData()
        //         for (let i = 0; i < data.nodes.length; i++) {
        //           this.lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
        //             isShowDelete: false
        //           });
        //         }
        //         this.lf.graphModel.getNodeModelById(this.activeNodes[0].id).setProperties({
        //           isShowDelete: true
        //         });
        //         // if (this.activeNodes[0].properties.width && this.activeNodes[0].properties.height) {
        //         //   this.$_setStyle({
        //         //     id: this.activeNodes[0].id,
        //         //     type: this.activeNodes[0].type,
        //         //     width: this.activeNodes[0].properties.width,
        //         //     height: this.activeNodes[0].properties.height
        //         //   })
        //         // }
        //         if (this.activeNodes[0].properties.nodeSize && this.activeNodes[0].properties.nodeSize.width && this.activeNodes[0].properties.nodeSize.height) {
        //           this.$_setStyle({
        //             id: this.activeNodes[0].id,
        //             type: this.activeNodes[0].type,
        //             width: this.activeNodes[0].properties.nodeSize.width,
        //             height: this.activeNodes[0].properties.nodeSize.height
        //           })
        //         }
        //         else {
        //           this.$_setStyle({
        //             id: this.activeNodes[0].id,
        //             type: this.activeNodes[0].type,
        //           })
        //         }
        //         this.iconList = this.activeNodes[0].properties.iconList
        //         this.imageList = this.activeNodes[0].properties.imageList
        //         this.videoList = this.activeNodes[0].properties.videoList
        //         this.audioList = this.activeNodes[0].properties.audioList
        //         this.fileList = this.activeNodes[0].properties.fileList
        //       }
        //       if (this.activeNodes[0].type == 'icon-theme' || ((this.activeNodes[0].type == 'icon-stage' && !this.activeNodes[0].properties.stageContent) || (this.activeNodes[0].type == 'icon-stage' && this.activeNodes[0].properties.stageContent && this.activeNodes[0].properties.stageContent == "<p></p>")) || ((this.activeNodes[0].type == 'icon-task' && !this.activeNodes[0].properties.taskContent) || (this.activeNodes[0].type == 'icon-task' && this.activeNodes[0].properties.taskContent && this.activeNodes[0].properties.taskContent == "<p></p>")) || ((this.activeNodes[0].type == 'icon-homework' && !this.activeNodes[0].properties.homeworkContent) || (this.activeNodes[0].type == 'icon-homework' && this.activeNodes[0].properties.homeworkContent && this.activeNodes[0].properties.homeworkContent == "<p></p>"))) {
        //         $("#text_" + this.activeNodes[0].id).css("display", "none")
        //         $("#input_" + this.activeNodes[0].id).css("display", "block")
        //         var sr = document.getElementById("input_" + this.activeNodes[0].id);
        //         var len = sr.value.length;
        //         this.setSelectionRange(sr, len, len);
        //       }
        //     }
        //   }
        //   else {
        //     this.lf.clearSelectElements()
        //     let data = this.lf.getGraphData()
        //     for (let i = 0; i < data.nodes.length; i++) {
        //       // if (data.nodes[i].properties.width && data.nodes[i].properties.height) {
        //       //   this.lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
        //       //     width: data.nodes[i].properties.width,
        //       //     height: data.nodes[i].properties.height,
        //       //     isShowDelete: false
        //       //   });
        //       // }
        //       if (data.nodes[i].properties.nodeSize && data.nodes[i].properties.nodeSize.width && data.nodes[i].properties.nodeSize.height) {
        //         this.lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
        //           width: data.nodes[i].properties.nodeSize.width,
        //           height: data.nodes[i].properties.nodeSize.height,
        //           isShowDelete: false
        //         });
        //       }
        //       else {
        //         this.lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
        //           isShowDelete: false
        //         });
        //       }
        //     }
        //   }
        // })
      });
      // 监听鼠标滚轮缩放画布
      this.lf.on("graph:transform", (data) => {
        $(".lf-background").css({
          "transform-origin": "0px 0px",
          transform:
            "matrix(" +
            data.transform.SCALE_X +
            "," +
            data.transform.SKEW_X +
            "," +
            data.transform.SKEW_Y +
            "," +
            data.transform.SCALE_Y +
            "," +
            data.transform.TRANSLATE_X +
            "," +
            data.transform.TRANSLATE_Y +
            ")",
        });
        $(".lf-diagram canvas").css({
          "transform-origin": "0px 0px",
          transform:
            "matrix(" +
            data.transform.SCALE_X +
            "," +
            data.transform.SKEW_X +
            "," +
            data.transform.SKEW_Y +
            "," +
            data.transform.SCALE_Y +
            "," +
            data.transform.TRANSLATE_X +
            "," +
            data.transform.TRANSLATE_Y +
            ")",
        });
        // let data_new = this.lf.getGraphData()
        // if(data_new.nodes && data_new.nodes.length != 0) {
        //   let min_node_y = find_min_y(data_new.nodes)
        //   let min_node_x = find_min_x(data_new.nodes)
        //   $(".lf-background").css({
        //     "transform-origin": (min_node_x.x - 125) * data.transform.SCALE_X + "px " + (min_node_y.y - 125) * data.transform.SCALE_Y + "px",
        //     "transform": "matrix(" + data.transform.SCALE_X + "," + data.transform.SKEW_X + "," + data.transform.SKEW_Y + "," + data.transform.SCALE_Y + "," + (data.transform.TRANSLATE_X - Math.abs(min_node_x.x - 125) * data.transform.SCALE_X) + "," + (data.transform.TRANSLATE_Y - Math.abs(min_node_y.y - 125) * data.transform.SCALE_Y) + ")"
        //   })
        //   $(".lf-diagram canvas").css({
        //     "transform-origin": (min_node_x.x - 125) * data.transform.SCALE_X + "px " + (min_node_y.y - 125) * data.transform.SCALE_Y + "px",
        //     "transform": "matrix(" + data.transform.SCALE_X + "," + data.transform.SKEW_X + "," + data.transform.SKEW_Y + "," + data.transform.SCALE_Y + "," + (data.transform.TRANSLATE_X - Math.abs(min_node_x.x - 125) * data.transform.SCALE_X) + "," + (data.transform.TRANSLATE_Y - Math.abs(min_node_y.y - 125) * data.transform.SCALE_Y) + ")"
        //   })
        // }
        // else {
        //   $(".lf-background").css({
        //     "transform-origin": "0px 0px",
        //     "transform": "matrix(" + data.transform.SCALE_X + "," + data.transform.SKEW_X + "," + data.transform.SKEW_Y + "," + data.transform.SCALE_Y + "," + data.transform.TRANSLATE_X + "," + data.transform.TRANSLATE_Y + ")"
        //   })
        //   $(".lf-diagram canvas").css({
        //     "transform-origin": "0px 0px",
        //     "transform": "matrix(" + data.transform.SCALE_X + "," + data.transform.SKEW_X + "," + data.transform.SKEW_Y + "," + data.transform.SCALE_Y + "," + data.transform.TRANSLATE_X + "," + data.transform.TRANSLATE_Y + ")"
        //   })
        // }
        // changeCanvas(data.transform.SCALE_X)
        if (data.type == "zoom") {
          if (Math.round(data.transform.SCALE_X * 100) > 400) {
            this.lf.zoom(4);
            this.transformSize = 400;
            // $(".lf-background-area").css("transform","scale(4)")
          } else if (Math.round(data.transform.SCALE_X * 100) < 24) {
            this.lf.zoom(0.24);
            this.transformSize = 24;
            // $(".lf-background-area").css("transform","scale(4)")
          } else {
            this.transformSize = Math.round(data.transform.SCALE_X * 100);
            // $(".lf-background-area").css("transform","scale(" + data.transform.SCALE_X + ")")
          }
        }
      });
      // this.lf.on('node:mouseleave', ({ data }) => {
      //   if (this.isResizeNode) {
      //     console.log(data)
      //     setTimeout(() => {
      //       this.sendUpdate(newNodes, newEdges, "update", 0)
      //     }, 1000)
      //     this.isResizeNode = false
      //   }
      // })
      // var _this = this;
      // setInterval(function () {
      //   const data = _this.lf.getGraphData()
      //   // data.backgroundUrl = localStorage.getItem("background")
      //   // localStorage.setItem("data", JSON.stringify(data));
      //   // Notification.info({
      //   //   title: '消息',
      //   //   message: '数据已经自动保存',
      //   //   duration: 3000,
      //   //   offset: 50,
      //   //   showClose: false
      //   // });
      //   // const data1 = _this.lf.getSelectElements()
      //   // console.log(data1)
      //   // console.log(_this.lf.extension.selectionSelect)
      //   for (let i = 0; i < data.nodes.length; i++) {
      //     $("#" + data.nodes[i].id).on("click", function (e) {
      //       // console.log(that.activeNodes[0].id)
      //       let nodes = []
      //       nodes.push(data.nodes[i])
      //       that.$confirm(that.languageData.tip18, that.languageData.tip2, {
      //         confirmButtonText: that.languageData.confirm,
      //         cancelButtonText: that.languageData.cancel,
      //         type: 'warning'
      //       }).then(() => {
      //         //删除数组的元素
      //         let id_index = data.nodes.findIndex((item) => {
      //           return item.id == data.nodes[i].id;
      //         })
      //         // localStorage.data = JSON.stringify(data)
      //         that.isDeleteNode = true
      //         let newEdges = []
      //         let outgoingEdgeModel = that.lf.getNodeOutgoingEdge(data.nodes[i].id);
      //         if (outgoingEdgeModel.length != 0) {
      //           for (let j = 0; j < outgoingEdgeModel.length; j++) {
      //             let edge = that.lf.getEdgeModelById(outgoingEdgeModel[j].id)
      //             newEdges.push(edge.getData())
      //           }
      //         }
      //         let incomingEdgeModel = that.lf.getNodeIncomingEdge(data.nodes[i].id);
      //         if (incomingEdgeModel.length != 0) {
      //           for (let j = 0; j < incomingEdgeModel.length; j++) {
      //             let edge = that.lf.getEdgeModelById(incomingEdgeModel[j].id)
      //             newEdges.push(edge.getData())
      //           }
      //         }
      //         that.sendUpdate(nodes, newEdges, "delete", 0)
      //         that.lf.deleteNode(data.nodes[i].id)
      //         that.isDeleteNode = false
      //         data.nodes.splice(id_index, 1)
      //         that.lf.clearSelectElements()
      //         let newData = {
      //           "nodes": nodes,
      //           "edges": newEdges,
      //           "backgroundUrl": localStorage.getItem("background")
      //         }
      //         that.add_Operation(newData, "deleteNode")
      //       }).catch(() => {
      //         // this.$message({
      //         //   type: 'info',
      //         //   message: '已取消删除'
      //         // });
      //       });
      //       e.stopPropagation();
      //     })
      //   }
      // }, 3000)

      $(".lf-drag-able").attr("data-marpit-svg", "");
      $(".modification-overlay").attr("data-marpit-svg", "");
    },
    // 获取可以进行设置的属性
    $_getProperty() {
      let properties = {};
      const { nodes, edges } = this.lf.getSelectElements();
      nodes.forEach((node) => {
        properties = { ...properties, ...node.properties };
      });
      edges.forEach((edge) => {
        properties = { ...properties, ...edge.properties };
      });
      this.properties = properties;
      return properties;
    },
    crossFun(ele) {
      var width = document.documentElement.clientWidth;
      var height = document.documentElement.clientHeight;
      //第一次进来  判断是不是横屏
      if (width < height) {
        ele.style.width = height + "px";
        ele.style.height = width + "px";
        ele.style.top = (height - width) / 2 + "px";
        ele.style.left = 0 - (height - width) / 2 + "px";
        ele.style.transform = "rotate(90deg)";
        ele.style.transformOrign = "50% 50%";
        ele.style.position = "relative";
      }
      //设备旋转或者窗口变化时候进行  横竖屏处理     在来回切换的时候回出现BUG  使用定时器解决
      var evt =
        "onorientationchange" in window ? "orientationchange" : "resize";

      window.addEventListener(
        evt,
        function () {
          setTimeout(function () {
            var width = document.documentElement.clientWidth;
            var height = document.documentElement.clientHeight;
            if (width > height) {
              ele.style.width = width + "px";
              ele.style.height = height + "px";
              ele.style.top = 0;
              ele.style.left = 0;
              ele.style.transform = "none";
              ele.style.transformOrign = "50% 50%";
              ele.style.position = "relative";
            } else {
              ele.style.width = height + "px";
              ele.style.height = width + "px";
              ele.style.top = (height - width) / 2 + "px";
              ele.style.left = 0 - (height - width) / 2 + "px";
              ele.style.transform = "rotate(90deg)";
              ele.style.transformOrign = "50% 50%";
              ele.style.position = "relative";
            }
          }, 100);
        },
        false
      );
    },
    checkCode() {
      let that = this;
      let themeId = "111";
      if (window.location.href.indexOf("&tid=") != -1) {
        themeId = window.location.href.split("&tid=")[1].split("&cid=")[0];
      }
      let cid = window.location.href.split("&cid=")[1];
      that.$ajax
        .post(`${GPT_BASE_URL}/get_invitation_code`, {
          uid: cid,
          tid: themeId,
          type: that.type,
        })
        .then(function (response) {
          let code = JSON.parse(response.data.FunctionResponse)[0]
            .invitationCode;
          if (that.code == code) {
            that.code = "";
            that.isExitCode = false;
            let loadingInstance = Loading.service({ fullscreen: true });
            that.getcscl(cid, loadingInstance, themeId);
          } else {
            that.code = "";
            that.$message.error(that.languageData.tip103);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    createDemoList(val) {
      this.DemoLists = val;
      this.isProjection = true;
      this.isShowDemoList = true;
      this.isExitPrevious = false;
      this.isExitNext = true;
      this.showDemoList = [this.DemoLists[0]];
      this.dialogVisible = false;
      this.DemonstrateDialogVisible = true;
      let that = this;
      that.Show = false;
      setTimeout(function () {
        that.Show = true;
      }, 100);
      this.screenWidth = window.screen.width;
      window.addEventListener('resize', () => {
        this.screenWidth = window.screen.width;
      });
      this.$_fullScreen();
    },
    getNavigationList(val) {
      this.navigationList = val;
    },
    getThemeName(val) {
      this.themeName = val;
    },
    getInfo(value) {
      // value 就是子组件传递过来的数据
      this.dialogVisible = value;
      this.dataList = [];
      this.sourceDataList = [];
      // window.location.reload()
    },
    getDemonstrateInfo(value) {
      document.getElementById("share").removeAttribute("style");
      document.getElementById("share").setAttribute("style", "height:100%;");
      this.DemonstrateDialogVisible = value;
      this.isProjection = false;
      this.isExitNext = false;
      this.isExitPrevious = false;
      this.isShowDemoList = false;
      this.DemoLists = [];
      this.demoIndex = 0;
      this.showDemoList = [];
      this.screenWidth = 970;
      if (!this.isDemo) {
        this.dialogVisible = true;
      }
    },
    getData() {
      let that = this;
      let themeId = "";
      if (window.location.href.indexOf("&tid=") != -1) {
        that.type = window.location.href.split("?type=")[1].split("&tid=")[0];
        themeId = window.location.href.split("&tid=")[1].split("&cid=")[0];
      } else {
        that.type = window.location.href.split("?type=")[1].split("&cid=")[0];
      }
      let cid = window.location.href.split("&cid=")[1];
      that.session_name = uuidv4();
      // 0表示分享生成，1表示仅分享演示，4表示分享主页面
      if (that.type == 0 || that.type == 1 || that.type == 4) {
        if (that.type == 4) {
          touchInit();
        }
        that.isExitCode = false;
        let loadingInstance = Loading.service({ fullscreen: true });
        that.getcscl(cid, loadingInstance, themeId);
      }
      // 2表示分享生成，需要邀请码
      else if (that.type == 2) {
        that.isExitCode = true;
      }
      // 3表示仅分享演示，需要邀请码
      else if (that.type == 3) {
        that.isExitCode = true;
      }
      // 5表示分享主页面，需要邀请码
      else if (that.type == 5) {
        touchInit();
        that.isExitCode = true;
      }
    },
    getcscl(id, loadingInstance, themeId) {
      let that = this;
      let params =
        window.location.href.indexOf("localhost") != -1 ||
        window.location.href.indexOf("192.168") != -1
          ? "mode=" + ["getcscldata", id, "", ""].join(",")
          : "mode=" + ["getcscldata", id, "", ""].join(",");
      that.$ajax
        .post("https://poll.cocorobo.cn", params)
        .then((res) => {
          console.log(res);
          let data = {};
          try {
            data = JSON.parse(res.data[0][0].data);
          } catch {
            data = res.data[0][0].data;
          }
          let nodes = data.nodes;
          let edges = data.edges;
          let newNodes = [];
          let newEdges = [];
          let nodeList = [];
          for (let i = 0; i < nodes.length; i++) {
            if (nodes[i].id == themeId) {
              nodeList.push(nodes[i]);
              break;
            }
          }
          for (let i = 0; i < nodes.length; i++) {
            if (nodes[i] !== null && typeof nodes[i] === "object") {
              newNodes.push(nodes[i]);
            }
          }
          for (let i = 0; i < edges.length; i++) {
            if (edges[i] !== null && typeof edges[i] === "object") {
              newEdges.push(edges[i]);
            }
          }
          data.nodes = newNodes;
          data.edges = newEdges;
          if (that.type == 0 || that.type == 2) {
            that.isDemo = false;
            that.$_runGraph(data, nodeList);
          } else if (that.type == 1) {
            that.screenWidth = window.screen.width;
            window.addEventListener('resize', () => {
              this.screenWidth = window.screen.width;
            });
            MessageBox.alert(that.languageData.tip89, that.languageData.tip2, {
              confirmButtonText: that.languageData.tip90,
              showClose: false,
              callback: () => {
                that.isDemo = true;
                that.$_runGraph(data, nodeList);
                that.dialogVisible = false;
                that.$nextTick(() => {
                  $("#createProjection").click();
                });
              },
            });
          } else if (that.type == 3) {
            that.screenWidth = window.screen.width;
            window.addEventListener('resize', () => {
              this.screenWidth = window.screen.width;
            });
            that.isDemo = true;
            that.$_runGraph(data, nodeList);
            that.dialogVisible = false;
            that.$nextTick(() => {
              $("#createProjection").click();
            });
          } else if (that.type == 4 || that.type == 5) {
            that.initLogicFlow(data);
          }
          loadingInstance.close();
        })
        .catch((err) => {
          console.error(err);
          loadingInstance.close();
          that.$message({
            message: err,
            type: "error",
          });
        });
    },
    //全屏
    fullele() {
      return (
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement ||
        document.mozFullScreenElement ||
        null
      );
    },
    //判断是否全屏
    isFullScreen() {
      return !!(document.webkitIsFullScreen || this.fullele());
    },
    init() {
      if (screenfull.isEnabled) {
        screenfull.on("change", this.fullChange);
      }
    },
    /*
      全屏事件或者退出全屏事件
    */
    $_fullScreen() {
      if (!screenfull.isEnabled) {
        // this.$message({
        //   message: "Your browser does not work",
        //   type: "warning",
        // });
        this.crossFun(document.getElementById("share"));
        return false;
      }
      screenfull.toggle(document.documentElement, {
        navigationUI: !screenfull.isFullscreen ? "hide" : "show",
      });
      this.$nextTick(() => {
        $(".diagram-sidebar").css("display", "flex");
      });
    },
    fullChange() {
      // this.$emit("full", screenfull.isFullscreen)
      this.isFullscreen = screenfull.isFullscreen;
      if (screenfull.isFullscreen) {
        this.$nextTick(() => {
          // $(".header_bg").css("display", "none");
          $(".diagram-main").css("height", "100%");
        });

        var os = (function () {
          var ua = navigator.userAgent,
            isWindowsPhone = /(?:Windows Phone)/.test(ua),
            isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
            isAndroid = /(?:Android)/.test(ua),
            isFireFox = /(?:Firefox)/.test(ua),
            isChrome = /(?:Chrome|CriOS)/.test(ua),
            isTablet =
              /(?:iPad|PlayBook)/.test(ua) ||
              (isAndroid && !/(?:Mobile)/.test(ua)) ||
              (isFireFox && /(?:Tablet)/.test(ua)),
            isPhone = /(?:iPhone)/.test(ua) && !isTablet,
            isPc = !isPhone && !isAndroid && !isSymbian;
          return {
            isTablet: isTablet,
            isPhone: isPhone,
            isAndroid: isAndroid,
            isPc: isPc,
            isChrome: isChrome,
          };
        })();

        if (os.isAndroid && os.isTablet) {
          // 锁定屏幕方向为横屏
          const screenOrientation =
            screen.orientation || screen.mozOrientation || screen.msOrientation;
          if (screenOrientation && screenOrientation.lock) {
            screenOrientation.lock("landscape").catch((error) => {
              // 锁定屏幕方向失败时的处理
              console.error("Screen orientation lock failed", error);
            });
          } else {
            console.warn("Screen orientation API not supported");
          }
        } else {
          if (this.isPhone) {
            this.crossFun(document.getElementById("share"));
          }
        }
      } else {
        // this.lf.updateEditConfig({
        //   isSilentMode: false,
        // });
        this.isShowDemoList = false;
        this.isProjection = false;
        this.selectNextDialogVisible = false;
        this.selectPreviousDialogVisible = false;
        this.DemonstrateDialogVisible = false;
        if (!this.isDemo) {
          this.dialogVisible = true;
        }
        // this.$nextTick(() => {
        //   // $(".header_bg").css("display", "flex");
        //   $(".diagram-main").css("height", "100%");
        // })
      }
    },
    /*
        运行事件
    */
    $_runGraph(data, nodes) {
      // let data = this.lf.getGraphData()
      // console.log(data.edges)
      this.dataList = [];
      this.sourceDataList = [];

      let themeNum = 0;
      for (let i = 0; i < data.nodes.length; i++) {
        if (data.nodes[i].type == "icon-theme") {
          themeNum = themeNum + 1;
        }
      }

      if (data.nodes.length != 0 && data.edges.length != 0) {
        let isRun = true;
        for (let i = 0; i < data.edges.length; i++) {
          if (data.edges[i].type.indexOf("pro-red") != -1) {
            isRun = false;
            break;
          }
        }

        if (isRun) {
          // console.log(this.dataList)
          this.sourceDataList.push(data);

          // 获取所有节点的id列表
          var nodeIdList = [];
          for (let i = 0; i < data.nodes.length; i++) {
            nodeIdList.push(data.nodes[i].id);
          }
          // 获取所有连线的目标节点id列表
          var targetNodeIdList = [];
          for (let i = 0; i < data.edges.length; i++) {
            targetNodeIdList.push(data.edges[i].targetNodeId);
          }
          // 获取所有连线的源节点id列表
          var sourceNodeIdList = [];
          for (let i = 0; i < data.edges.length; i++) {
            sourceNodeIdList.push(data.edges[i].sourceNodeId);
          }
          // 获取图上的根节点id
          var firstNodeId = "";
          // for (let i = 0; i < nodeIdList.length; i++) {
          //   if (targetNodeIdList.includes(nodeIdList[i]) == false) {
          //     firstNodeId = nodeIdList[i]
          //   }
          // }
          for (let i = 0; i < data.nodes.length; i++) {
            nodeIdList.push(data.nodes[i].id);
            if (
              data.nodes[i].type == "icon-start" ||
              data.nodes[i].type == "icon-theme"
            ) {
              firstNodeId = data.nodes[i].id;
            }
          }
          if (firstNodeId != "") {
            // 获取图上的最后节点id列表
            var lastNodeIdList = [];
            for (let i = 0; i < nodeIdList.length; i++) {
              if (sourceNodeIdList.includes(nodeIdList[i]) == false) {
                lastNodeIdList.push(nodeIdList[i]);
              }
            }
            // 获取自定义的所有连线列表
            let finalEedges = [];
            for (let i = 0; i < data.edges.length; i++) {
              let edges = data.edges[i];
              for (let j = 0; j < data.nodes.length; j++) {
                if (edges.targetNodeId == data.nodes[j].id) {
                  edges.targetNode = data.nodes[j];
                  break;
                }
              }
              finalEedges.push(edges);
            }
            // const { nodes } = this.lf.getSelectElements();
            // this.activeNodes = [];
            let list = [];
            if (nodes.length != 0 && nodes[0].type == "icon-theme") {
              firstNodeId = nodes[0].id;
              for (let j = 0; j < data.nodes.length; j++) {
                if (data.nodes[j].id == firstNodeId) {
                  finalEedges.push({
                    id: "0000",
                    sourceNodeId: "0",
                    targetNodeId: firstNodeId,
                    targetNode: data.nodes[j],
                  });
                  break;
                }
              }
              let tempList = this.deepFilter(
                this.convertToTreeData(finalEedges, nodes[0].id),
                nodeIdList,
                lastNodeIdList
              );
              // console.log(tempList)
              if (tempList.length == 0) {
                this.$message.error(this.languageData.tip4);
              }
              // else if(tempList.length != 0 && tempList[0].children.length == 0) {
              //   this.$message.error(this.languageData.tip4);
              // }
              else {
                nodes[0].children = tempList;
                list = nodes;
                let finalDataList = { id: "0", children: list };
                this.isHomeWork = false;
                this.dialogVisible = true;
                this.dataList.push(finalDataList);
              }
            }
            // else if (nodes.length == 0 && themeNum == 1) {
            //   for (let j = 0; j < data.nodes.length; j++) {
            //     if (data.nodes[j].id == firstNodeId) {
            //       finalEedges.push({
            //         id: "0000",
            //         sourceNodeId: "0",
            //         targetNodeId: firstNodeId,
            //         targetNode: data.nodes[j],
            //       });
            //       break;
            //     }
            //   }
            //   // 处理数据获取树状结构数据
            //   list = this.deepFilter(
            //     this.convertToTreeData(finalEedges, "0"),
            //     nodeIdList,
            //     lastNodeIdList
            //   );
            //   if (list.length == 0) {
            //     this.$message.error(this.languageData.tip4);
            //   }
            //   // else if (list.length != 0 && list[0].children.length == 0) {
            //   //   this.$message.error(this.languageData.tip4);
            //   // }
            //   else {
            //     let finalDataList = { id: "0", children: list };
            //     this.isHomeWork = false;
            //     this.dialogVisible = true;
            //     this.dataList.push(finalDataList);
            //   }
            // }
            // else if (
            //   (nodes.length != 0 &&
            //     nodes[0].type != "icon-theme" &&
            //     nodes[0].type != "icon-task") ||
            //   (nodes.length == 0 && themeNum > 1)
            // ) {
            //   this.$message.error(this.languageData.tip22);
            // } else if (nodes.length != 0 && nodes[0].type == "icon-task") {
            //   firstNodeId = nodes[0].id;
            //   for (let j = 0; j < data.nodes.length; j++) {
            //     if (data.nodes[j].id == firstNodeId) {
            //       finalEedges.push({
            //         id: "0000",
            //         sourceNodeId: "0",
            //         targetNodeId: firstNodeId,
            //         targetNode: data.nodes[j],
            //       });
            //       break;
            //     }
            //   }
            //   // 处理数据获取树状结构数据
            //   list = this.deepFilter(
            //     this.convertToTreeData(finalEedges, nodes[0].id),
            //     nodeIdList,
            //     lastNodeIdList
            //   );
            //   // console.log(list)
            //   if (list.length == 0) {
            //     this.$message.error(this.languageData.tip4);
            //   }
            //   // else if (list.length != 0 && list[0].children.length == 0) {
            //   //   this.$message.error(this.languageData.tip4);
            //   // }
            //   else {
            //     nodes[0].children = list;
            //     list = nodes;
            //     let finalDataList = { id: "0", children: list };
            //     this.isHomeWork = true;
            //     this.dialogVisible = true;
            //     this.dataList.push(finalDataList);
            //   }
            // }
            // if (list[0].children.length == 0) {
            //   this.$message.error('请从起始点出发，顺序连接所有需要运行的卡片内容');
            // }
            // else {
            //   let finalDataList = { 'id': "0", 'children': list }
            //   // console.log(finalDataList)

            //   this.dialogVisible = true;
            //   this.dataList.push(finalDataList);
            //   // for (var i = 0; i < this.dataList[0].nodes.length; i++) {
            //   //   if (this.dataList[0].nodes[i].type == "icon-select") {
            //   //     this.selectIndex.push(i);
            //   //   }
            //   // }

            //   // var listData;
            //   // for (let j = 0; j < data.nodes.length; j++) {
            //   //   if (data.nodes[j].id == firstNodeId) {
            //   //     listData = data.nodes[j]
            //   //     break;
            //   //   }
            //   // }
            //   // console.log(listData)
            // }
            else if (nodes.length != 0 && nodes[0].type == "icon-task") {
              firstNodeId = nodes[0].id;
              for (let j = 0; j < data.nodes.length; j++) {
                if (data.nodes[j].id == firstNodeId) {
                  finalEedges.push({
                    id: "0000",
                    sourceNodeId: "0",
                    targetNodeId: firstNodeId,
                    targetNode: data.nodes[j],
                  });
                  break;
                }
              }
              // 处理数据获取树状结构数据
              list = this.deepFilter(
                this.convertToTreeData(finalEedges, nodes[0].id),
                nodeIdList,
                lastNodeIdList
              );
              // console.log(list)
              if (list.length == 0) {
                this.$message.error(this.languageData.tip4);
              }
              // else if (list.length != 0 && list[0].children.length == 0) {
              //   this.$message.error(this.languageData.tip4);
              // }
              else {
                nodes[0].children = list;
                list = nodes;
                let finalDataList = { id: "0", children: list };
                this.isHomeWork = false;
                this.dialogVisible = true;
                this.dataList.push(finalDataList);
              }
            }
          } else {
            this.$message.error(this.languageData.tip5);
          }
        } else {
          this.$message.error(this.languageData.tip6);
        }
      } else if (data.nodes.length != 0 && data.edges.length == 0) {
        this.$message.error(this.languageData.tip4);
      }
      // this.download(this.filename, JSON.stringify(data))
      // console.log(this.dataList)
    },
    /*
      演示事件
    */
    $_projection(data, nodes) {
      // this.isShowDemoList = false
      if (!this.isProjection) {
        // this.top_menu = true
        // this.lf.updateEditConfig({
        //   isSilentMode: true,
        // });
        // let data = this.lf.getGraphData()
        // console.log(data.edges)
        if (data.nodes.length != 0 && data.edges.length != 0) {
          let isRun = true;
          for (let i = 0; i < data.edges.length; i++) {
            if (data.edges[i].type.indexOf("pro-red") != -1) {
              isRun = false;
              break;
            }
          }

          if (isRun) {
            // console.log(this.dataList)

            // 获取所有节点的id列表
            var nodeIdList = [];
            for (let i = 0; i < data.nodes.length; i++) {
              nodeIdList.push(data.nodes[i].id);
            }
            // 获取所有连线的目标节点id列表
            var targetNodeIdList = [];
            for (let i = 0; i < data.edges.length; i++) {
              targetNodeIdList.push(data.edges[i].targetNodeId);
            }
            // 获取所有连线的源节点id列表
            var sourceNodeIdList = [];
            for (let i = 0; i < data.edges.length; i++) {
              sourceNodeIdList.push(data.edges[i].sourceNodeId);
            }
            // 获取图上的根节点id
            var firstNodeId = "";
            // for (let i = 0; i < nodeIdList.length; i++) {
            //   if (targetNodeIdList.includes(nodeIdList[i]) == false) {
            //     firstNodeId = nodeIdList[i]
            //   }
            // }
            for (let i = 0; i < data.nodes.length; i++) {
              nodeIdList.push(data.nodes[i].id);
              if (
                data.nodes[i].type == "icon-start" ||
                data.nodes[i].type == "icon-theme"
              ) {
                firstNodeId = data.nodes[i].id;
              }
            }
            if (firstNodeId != "") {
              // 获取图上的最后节点id列表
              var lastNodeIdList = [];
              for (let i = 0; i < nodeIdList.length; i++) {
                if (sourceNodeIdList.includes(nodeIdList[i]) == false) {
                  lastNodeIdList.push(nodeIdList[i]);
                }
              }
              // 获取自定义的所有连线列表
              let finalEedges = [];
              for (let i = 0; i < data.edges.length; i++) {
                let edges = data.edges[i];
                for (let j = 0; j < data.nodes.length; j++) {
                  if (edges.targetNodeId == data.nodes[j].id) {
                    edges.targetNode = data.nodes[j];
                    break;
                  }
                }
                finalEedges.push(edges);
              }
              for (let j = 0; j < data.nodes.length; j++) {
                if (data.nodes[j].id == firstNodeId) {
                  finalEedges.push({
                    id: "0000",
                    sourceNodeId: "0",
                    targetNodeId: firstNodeId,
                    targetNode: data.nodes[j],
                  });
                  break;
                }
              }
              //   const { nodes } = this.lf.getSelectElements()
              this.activeNodes = [];
              let list = [];
              this.isChangeRate = true;
              if (nodes.length != 0) {
                let tempList = this.deepFilter(
                  this.convertToTreeData(finalEedges, nodes[0].id),
                  nodeIdList,
                  lastNodeIdList
                );
                nodes[0].children = tempList;
                list = nodes;
                // this.$emit("full", true)
                let finalDataList = { id: "0", children: list };
                // const { transformModel } = this.lf.graphModel;
                // transformModel.zoom(4, [finalDataList.children[0].x, finalDataList.children[0].y])
                // transformModel.focusOn(finalDataList.children[0].x, finalDataList.children[0].y, window.screen.width, window.screen.height);
                this.currentProjection = finalDataList.children;
                this.isExitPrevious = true;
                this.isExitNext = true;
                let previousNode = this.lf.getNodeIncomingNode(
                  this.currentProjection[0].id
                );
                if (previousNode.length == 0) {
                  this.isExitPrevious = false;
                }
                let NextNode = this.lf.getNodeOutgoingNode(
                  this.currentProjection[0].id
                );
                if (NextNode.length == 0) {
                  this.isExitNext = false;
                }
                this.lf.clearSelectElements();
                this.isProjection = true;
                // this.$nextTick(() => {
                //   // $(".header_bg").css("display", "none");
                //   $(".diagram-sidebar").css("display", "none");
                //   $(".diagram-main").css("height", "100%");
                // })
                this.showDemoList = [finalDataList.children[0]];
                this.DemonstrateDialogVisible = true;
                this.$_fullScreen();
              } else {
                // 处理数据获取树状结构数据
                list = this.deepFilter(
                  this.convertToTreeData(finalEedges, "0"),
                  nodeIdList,
                  lastNodeIdList
                );
                console.log("list", list);
                if (list[0].children.length == 0) {
                  this.$message.error(this.languageData.tip7);
                } else {
                  let finalDataList = { id: "0", children: list };
                  // this.$emit("full", true)
                  // const { transformModel } = this.lf.graphModel;
                  // transformModel.zoom(4, [finalDataList.children[0].x, finalDataList.children[0].y])
                  // transformModel.focusOn(finalDataList.children[0].x, finalDataList.children[0].y, window.screen.width, window.screen.height);
                  this.currentProjection = finalDataList.children;
                  this.isExitPrevious = true;
                  this.isExitNext = true;
                  let previousNode = this.lf.getNodeIncomingNode(
                    this.currentProjection[0].id
                  );
                  if (previousNode.length == 0) {
                    this.isExitPrevious = false;
                  }
                  let NextNode = this.lf.getNodeOutgoingNode(
                    this.currentProjection[0].id
                  );
                  if (NextNode.length == 0) {
                    this.isExitNext = false;
                  }
                  this.lf.clearSelectElements();
                  this.isProjection = true;
                  // this.$nextTick(() => {
                  //   // $(".header_bg").css("display", "none");
                  //   $(".diagram-sidebar").css("display", "none");
                  //   $(".diagram-main").css("height", "100%");
                  // })
                  this.showDemoList = [finalDataList.children[0]];
                  this.DemonstrateDialogVisible = true;
                  this.$_fullScreen();
                }
              }
              // if (list[0].children.length == 0) {
              //   this.$message.error('请从起始点出发，顺序连接所有需要投影的卡片内容');
              // }
              // else {
              //   let finalDataList = { 'id': "0", 'children': list }
              //   const { transformModel, width, height } = this.lf.graphModel;
              //   transformModel.zoom(3)
              //   transformModel.focusOn(finalDataList.children[0].x, finalDataList.children[0].y, width, height);
              //   this.currentProjection = finalDataList.children;
              //   this.isExitPrevious = true
              //   this.isExitNext = true
              //   let previousNode = this.lf.getNodeIncomingNode(this.currentProjection[0].id)
              //   if (previousNode.length == 0) {
              //     this.isExitPrevious = false
              //   }
              //   let NextNode = this.lf.getNodeOutgoingNode(this.currentProjection[0].id)
              //   if (NextNode.length == 0) {
              //     this.isExitNext = false
              //   }
              //   this.lf.clearSelectElements()
              // }
            } else {
              this.$message.error(this.languageData.tip5);
              // this.lf.updateEditConfig({
              //   isSilentMode: false,
              // });
            }
          } else {
            this.$message.error(this.languageData.tip8);
            // this.lf.updateEditConfig({
            //   isSilentMode: false,
            // });
          }
        }
      } else {
        // this.$nextTick(() => {
        //   $(".header_bg").css("display", "flex");
        //   $(".diagram-sidebar").css("display", "flex");
        //   $(".diagram-main").css("height", "94%");
        // })
        // this.lf.updateEditConfig({
        //   isSilentMode: false,
        // });
        clearTimeout(localStorage.top_menu);
        // this.top_menu = false
        this.isProjection = false;
        this.selectNextDialogVisible = false;
        this.selectPreviousDialogVisible = false;
        this.isChangeRate = false;
        // this.lf.resetZoom()
        // this.lf.resetTranslate()
        this.$_fullScreen();
      }
    },
    setSelectMulu(val) {
      let that = this;
      for (let i = 0; i < this.DemoLists.length; i++) {
        if (val == this.DemoLists[i].id) {
          if (i == 0) {
            this.isExitPrevious = false;
            this.isExitNext = true;
          } else if (i == this.DemoLists.length - 1) {
            this.isExitPrevious = true;
            this.isExitNext = false;
          } else {
            this.isExitPrevious = true;
            this.isExitNext = true;
          }
          this.demoIndex = i;
          this.showDemoList = [this.DemoLists[i]];
          that.Show = false;
          setTimeout(function () {
            that.Show = true;
          }, 100);
          break;
        }
      }
    },
    $_previous_projection() {
      // this.lf.updateEditConfig({
      //   isSilentMode: true,
      // });
      let that = this;
      if (!this.isShowDemoList) {
        let currentProjection = this.currentProjection;
        let previousNode = this.lf.getNodeIncomingNode(currentProjection[0].id);
        if (previousNode.length != 0) {
          if (previousNode.length != 1) {
            this.selectWayList = [];
            this.selectPreviousDialogVisible = true;
            for (let i = 0; i < previousNode.length; i++) {
              let node = this.lf.getNodeModelById(previousNode[i].id).getData();
              this.selectWayList.push(node);
            }
          } else {
            let newNode = this.lf
              .getNodeModelById(previousNode[0].id)
              .getData();
            this.currentProjection = [newNode];
            // const { transformModel } = this.lf.graphModel;
            // transformModel.focusOn(previousNode[0].x, previousNode[0].y, window.screen.width, window.screen.height);
            this.showDemoList = [newNode];
            this.DemonstrateDialogVisible = true;
            this.lf.clearSelectElements();
            let node = this.lf.getNodeIncomingNode(
              this.currentProjection[0].id
            );
            if (node.length != 0) {
              this.isExitPrevious = true;
              this.isExitNext = true;
            } else {
              this.isExitPrevious = false;
              this.isExitNext = true;
            }
            that.Show = false;
            setTimeout(function () {
              that.Show = true;
            }, 100);
          }
        }
      } else {
        this.DemonstrateDialogVisible = true;
        this.demoIndex = this.demoIndex - 1;
        if (this.demoIndex == 0) {
          this.isExitPrevious = false;
        }
        this.isExitNext = true;
        this.showDemoList = [this.DemoLists[this.demoIndex]];
        that.Show = false;
        setTimeout(function () {
          that.Show = true;
        }, 100);
      }
    },
    $_next_projection() {
      // this.lf.updateEditConfig({
      //   isSilentMode: true,
      // });
      let that = this;
      if (!this.isShowDemoList) {
        let currentProjection = this.currentProjection;
        let NextNode = this.lf.getNodeOutgoingNode(currentProjection[0].id);
        if (NextNode.length != 0) {
          if (NextNode.length != 1) {
            this.selectWayList = [];
            this.selectNextDialogVisible = true;
            for (let i = 0; i < NextNode.length; i++) {
              let node = this.lf.getNodeModelById(NextNode[i].id).getData();
              this.selectWayList.push(node);
            }
          } else {
            let newNode = this.lf.getNodeModelById(NextNode[0].id).getData();
            this.currentProjection = [newNode];
            // const { transformModel } = this.lf.graphModel;
            // transformModel.focusOn(NextNode[0].x, NextNode[0].y, window.screen.width, window.screen.height);
            this.showDemoList = [newNode];
            this.DemonstrateDialogVisible = true;
            this.lf.clearSelectElements();
            let node = this.lf.getNodeOutgoingNode(
              this.currentProjection[0].id
            );
            if (node.length != 0) {
              this.isExitPrevious = true;
              this.isExitNext = true;
            } else {
              this.isExitPrevious = true;
              this.isExitNext = false;
            }
            that.Show = false;
            setTimeout(function () {
              that.Show = true;
            }, 100);
          }
        }
      } else {
        this.demoIndex = this.demoIndex + 1;
        if (this.demoIndex == this.DemoLists.length - 1) {
          this.isExitNext = false;
        }
        this.isExitPrevious = true;
        this.showDemoList = [this.DemoLists[this.demoIndex]];
        this.DemonstrateDialogVisible = true;
        that.Show = false;
        setTimeout(function () {
          that.Show = true;
        }, 100);
      }
    },
    /*
      生成树状结构json
    */
    convertToTreeData(data, pid) {
      const result = [];
      let temp = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].sourceNodeId === pid) {
          const obj = data[i].targetNode;
          temp = this.convertToTreeData(data, data[i].targetNodeId);
          if (temp.length > 0) {
            obj.children = temp;
          }
          result.push(obj);
        }
      }
      return result;
    },
    /*
      递归生成所需树状结构数据
    */
    deepFilter(list, ids, lastIds) {
      console.log(list, ids, lastIds);
      // 使用filter 过滤当前层的数组
      return list.filter((item) => {
        // filter其实也是遍历
        // 把当前遍历的节点的children 也调用一次 deepFilter 函数，返回过滤后的数组重新赋值
        if (lastIds.indexOf(item.id) != -1) {
          item.children = [];
          // 最后判断当前节点是否符合过滤要求
        } else {
          item.children = this.deepFilter(item.children, ids, lastIds);
          // 最后判断当前节点是否符合过滤要求
        }
        return ids.indexOf(item.id) != -1;
      });
    },
  },
};
</script>

<style>
.login-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding-top: 10%;
  /* padding-top: 6%; */
  background-image: url(data:image/svg+xml;base64,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);
  /* background-color: #112346; */
  background-repeat: no-repeat;
  background-position: center right;
  background-size: 100%;
}

.login-container {
  border-radius: 10px;
  margin: 0px auto;
  width: 350px;
  /* width: 380px;
    height: 435px; */
  padding: 30px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  text-align: left;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
}

.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}
</style>

<style scoped>
.diagram * {
  box-sizing: border-box;
}

.diagram-main {
  display: flex;
  width: 100%;
  height: 100%;
  z-index: 1029;
  overflow: hidden;
}

.diagram-container {
  flex: 1;
  /* z-index:1029; */
  position: relative;
}

/* 由于背景图和gird不对齐，需要css处理一下 */
.diagram :deep() .lf-background {
  left: 0px;
}

.diagram-wrapper {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  position: relative;
}

.lf-diagram {
  /* box-shadow: 0px 0px 4px #838284; */
  width: 100%;
  height: 100%;
}

::-webkit-scrollbar {
  width: 3px;
  height: 3px;
  background: white;
  border-left: 1px solid #e8e8e8;
}

::-webkit-scrollbar-thumb {
  border-width: 1px;
  border-style: solid;
  border-color: #fff;
  border-radius: 6px;
  background: #c9c9c9;
}

::-webkit-scrollbar-thumb:hover {
  background: #b5b5b5;
}

.DiagramRBToolbarDiv {
  position: absolute;
  bottom: 20px;
  z-index: 10;
  right: 40px;
}

.lf-diagram canvas {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
}
</style>
